import TableSort from "@/components/table/tableSort.vue";
import CountryP from "@/components/tableP/country.vue";
import WarehouseP from "@/components/tableP/warehouse.vue";
import TransitWarehouseP from "@/components/tableP/transitWarehouse.vue";
import channelTypeP from "@/components/tableP/channelType.vue";
import CurrencyP from "@/components/tableP/currency.vue";
import staffP from "@/components/tableP/staff.vue";
import basketP from "@/components/tableP/basket.vue";
import ErrorImage from "@/assets/images/errImg.png";
import { Message } from "element-ui";
import { fieldPopoverAndCopy } from "@/plugins/processFieldStyle";
import { Platform } from "@/plugins/sharedStaticData";
import { i18n } from "@/main";
import Chinese from "@/languages/Chinese";
import AES from "@/mixins/AES";

// 复制文本
function copyText(text) {
  const textArea = document.createElement("textarea");
  textArea.value = text;
  document.body.appendChild(textArea);
  textArea.select();
  try {
    document.execCommand("copy");
    Message.success("已成功复制到剪贴板");
  } catch (err) {
    Message.error("无法复制到剪贴板");
  }
  document.body.removeChild(textArea);
}

function getFieldName({
  id,
  opts,
  optsIdField = "value",
  optsCnNameField = "cnName",
  optsEnNameField = "enName",
  locale = "zh",
  emptyContent = "-",
}) {
  let result = emptyContent;
  let data = opts.find((item) => item[optsIdField] == id);
  if (data) {
    result = data.langLabel
      ? i18n.t(data.langLabel)
      : locale === "zh"
      ? data[optsCnNameField]
      : data[optsEnNameField];
  }
  return result;
}

// 客户端 - 头程订单列表
let clientFirstLegOrderList = [
  {
    cnName: "头程单号",
    enName: "FirstLeg Order Number",
    key: "firstLegOrderNo",
    status: true,
    width: 120,
  },
  {
    cnName: "入库单号",
    enName: "warehouse entry number",
    key: "productEntryNo",
    status: true,
    width: 120,
  },
  {
    cnName: "目的仓库",
    enName: "Destination warehouse",
    key: "stockId",
    status: true,
    width: 120,
  },
  {
    cnName: "目的国家",
    enName: "destination country",
    key: "countryId",
    status: true,
    width: 120,
  },
  {
    cnName: "中转仓库",
    enName: "transshipmentdepot",
    key: "transitWarehouseId",
    status: true,
    width: 120,
  },
  {
    cnName: "商品货物属性",
    enName: "Commodity property",
    key: "productAttributeName",
    status: true,
    width: 120,
  },
  {
    cnName: "总申报价值(USD)",
    enName: "Total declared value(USD)",
    key: "sumUnitPrice",
    status: true,
    width: 120,
  },
  {
    cnName: "物流单号",
    enName: "tracking number",
    key: "containerNumber",
    status: true,
    width: 120,
  },
  {
    cnName: "交货方式",
    enName: "delivery type",
    key: "collectionNumber",
    status: true,
    width: 120,
  },
  {
    cnName: "渠道类型",
    enName: "Channel type",
    key: "channelType",
    status: true,
    width: 120,
  },
  {
    cnName: "总数量",
    enName: "total quantity",
    key: "totalQuantity",
    status: true,
    width: 120,
  },
  {
    cnName: "运送到中转仓方式",
    enName: "Shipping to transit warehouse method",
    key: "transitToWarehouseMethod",
    status: true,
    width: 120,
  },
  {
    cnName: "预约总重量(KG)",
    enName: "Reserved gross weight (KG)",
    key: "appointmentTotalWeight",
    status: true,
    width: 120,
  },
  {
    cnName: "预约总方数(M³)",
    enName: "Total number of reservations (M³)",
    key: "appointmentTotalVolume",
    status: true,
    width: 120,
  },
  {
    cnName: "预约总件数",
    enName: "Total number of appointments",
    key: "appointmentTotalPieces",
    status: true,
    width: 120,
  },
  {
    cnName: "实际总重量(KG)",
    enName: "Actual gross weight (KG)",
    key: "actualTotalWeight",
    status: true,
    width: 120,
  },
  {
    cnName: "实际总方数(M³)",
    enName: "Actual total number of squares (M³)",
    key: "actualTotalVolume",
    status: true,
    width: 120,
  },
  {
    cnName: "实际总件数",
    enName: "Total number of packages arrived",
    key: "arrivalTotalPieces",
    status: true,
    width: 120,
  },
  // {
  //   cnName: "是否API推送",
  //   enName: "Is API Push Enabled",
  //   key: "isAPPushOrder",
  //   status: true,
  //   width: 120,
  // },
  {
    cnName: "客户备注",
    enName: "Customer remarks",
    key: "customerRemarks",
    status: true,
    width: 120,
  },
  {
    cnName: "客服备注",
    enName: "Customer service remarks",
    key: "serviceRemarks",
    status: true,
    width: 120,
  },
  {
    cnName: "仓库备注",
    enName: "Warehouse note",
    key: "receiveGoodsRemarks",
    status: true,
    width: 120,
  },
  {
    cnName: "异常备注",
    enName: "Abnormal remarks",
    key: "abnormalRemarks",
    status: true,
    width: 120,
  },
  {
    cnName: "预计到中转仓时间",
    enName: "Estimated time to transit warehouse",
    key: "estimatedArrivalTime",
    status: true,
    width: 120,
  },
  {
    cnName: "预计到仓时间",
    enName: "Estimated time of arrival",
    key: "destinationArrivalTime",
    status: true,
    width: 120,
  },
  {
    cnName: "单号/货拉拉信息",
    enName: "odd Cargo pull information",
    key: "trackingInfo",
    status: true,
    width: 120,
  },
  {
    cnName: "装柜方式 / 装柜尺寸",
    enName: "Loading method / Loading size",
    key: "loadingMethodAndSize",
    status: true,
    width: 120,
  },
  {
    cnName: "中转仓收货时间",
    enName: "transit warehousereceiving time",
    key: "transferReceivedTime",
    status: true,
    width: 120,
  },
  {
    cnName: "装载时间",
    enName: "loading time",
    key: "containerLoadingTime",
    status: true,
    width: 120,
  },
  {
    cnName: "提交时间",
    enName: "submission time",
    key: "submissionTime",
    status: true,
    width: 120,
  },
  {
    cnName: "创建时间",
    enName: "creation time",
    key: "createTime",
    // sortName: "a.createTime",
    status: true,
    width: 120,
  },
  {
    cnName: "承运时间",
    enName: "transit time",
    key: "transitTime",
    status: true,
    width: 120,
  },
  {
    cnName: "创建人",
    enName: "creator",
    key: "createUserName",
    status: true,
    width: 120,
  },
];

// 客户端 - 头程账单列表
let clientFirstBillingList = [
  {
    cnName: "支付方式",
    enName: "payment type",
    key: "isPayment",
    status: true,
    width: 120,
  },
  {
    cnName: "头程订单号",
    enName: "First order number",
    key: "firstLegOrderNo",
    status: true,
    width: 120,
  },
  {
    cnName: "入库单单号",
    enName: "Entry number",
    key: "productEntryNo",
    status: true,
    width: 120,
  },
  {
    cnName: "目的仓库",
    enName: "Destination warehouse",
    key: "stockId",
    status: true,
    width: 120,
  },
  {
    cnName: "目的国家",
    enName: "destination country",
    key: "countryId",
    status: true,
    width: 120,
  },
  {
    cnName: "中转仓库",
    enName: "transshipmentdepot",
    key: "transitWarehouseId",
    status: true,
    width: 120,
  },
  {
    cnName: "货物属性",
    enName: "Property of goods",
    key: "productAttributeName",
    status: true,
    width: 120,
  },
  {
    cnName: "实际总方数(M³)",
    enName: "Actual total number of squares (M³)",
    key: "trueTotalCUBE",
    status: true,
    width: 120,
  },
  {
    cnName: "实际总重量 (KG)",
    enName: "Actual gross weight (KG)",
    key: "trueGrossWeight",
    status: true,
    width: 120,
  },
  {
    cnName: "计费总方数(M³)",
    enName: "Total number of billed squares (M³)",
    key: "actualTotalVolume",
    status: true,
    width: 120,
  },
  {
    cnName: "计费总重量 (KG)",
    enName: "Gross chargeable weight (KG)",
    key: "actualTotalWeight",
    status: true,
    width: 120,
  },
  {
    cnName: "实际总件数",
    enName: "Total number of packages arrived",
    key: "arrivalTotalPieces",
    status: true,
    width: 120,
  },
  {
    cnName: "总运费金额",
    enName: "Total freight",
    key: "totalFreightAmount",
    status: true,
    width: 120,
  },
  {
    cnName: "总附加费",
    enName: "Gross surcharge",
    key: "totalSurcharge",
    status: true,
    width: 120,
  },
  {
    cnName: "支付单号",
    enName: "Payment order number",
    key: "rechargeNumber",
    status: true,
    width: 120,
  },
  {
    cnName: "渠道类型",
    enName: "Channel type",
    key: "channelType",
    status: true,
    width: 120,
  },
  {
    cnName: "装柜方式",
    enName: "loading method ",
    key: "stuffingTypeName",
    status: true,
    width: 120,
  },
  {
    cnName: "装柜尺寸",
    enName: "packing dimensions",
    key: "stuffingSize",
    status: true,
    width: 120,
  },
  // {
  //   cnName: "结算单号",
  //   enName: "Statement number",
  //   key: "settlenumber",
  //   status: true,
  //   width: 120,
  // },
  {
    cnName: "创建时间",
    enName: "creation time",
    key: "createTime",
    // sortName: "a.createTime",
    status: true,
    width: 120,
  },
  {
    cnName: "付款时间",
    enName: "time of payment",
    key: "paymentTime",
    status: true,
    width: 120,
  },
  // {
  //   cnName: "结算时间",
  //   enName: "settleTime",
  //   key: "settleTime",
  //   status: true,
  //   width: 120,
  // },
  {
    cnName: "财务核实时间",
    enName: "Financial verification time",
    key: "financeVerifyTime",
    status: true,
    width: 120,
  },
  {
    cnName: "核实收款时间",
    enName: "Verify collection time",
    key: "verifyCollectionTime",
    status: true,
    width: 120,
  },
  // {
  //   cnName: "装载时间",
  //   enName: "loading time",
  //   key: "containerLoadingTime",
  //   status: true,
  //   width: 120,
  // },
  {
    cnName: "备注",
    enName: "Remark",
    key: "customerRemarks",
    status: true,
    width: 120,
  },
  {
    cnName: "客服备注",
    enName: "Customer service remarks",
    key: "serviceRemarks",
    status: true,
    width: 120,
  },
  {
    cnName: "财务备注",
    enName: "Financial remarks",
    key: "financeRemark",
    status: true,
    width: 120,
  },
  {
    cnName: "创建人",
    enName: "creator",
    key: "createUserName",
    status: true,
    width: 120,
  },
];

// 客户端 - 入库单列表
let clientWarehouseEntryList = [
  {
    cnName: "入库单号",
    enName: "warehouse entry number",
    key: "productEntryNo",
    status: true,
    width: 220,
  },
  {
    cnName: "头程单号",
    enName: "FirstLegOrderNumber",
    key: "trackingNo",
    status: true,
    width: 220,
  },
  {
    cnName: "仓库",
    enName: "warehouse",
    key: "warehouse",
    status: true,
    width: 180,
  },
  {
    cnName: "箱数",
    enName: "box quantity",
    key: "boxCount",
    sortName: "boxQty",
    status: true,
    width: 120,
  },
  {
    cnName: "SKU数量",
    enName: "Number of SKUs",
    key: "skuCount",
    status: true,
    width: 120,
  },
  {
    cnName: "预计到达仓时间",
    enName: "Estimated time of arrival",
    key: "estimatedArrivalDate",
    status: true,
    width: 150,
  },
  {
    cnName: "预约入库数量",
    enName: "Quantity of reserved storage",
    key: "appointedInboundQuantity",
    sortName: "estimatedArrivalNum",
    status: true,
    width: 120,
  },
  {
    cnName: "预约入库方数",
    enName: "Number of reserved storage parties",
    key: "appointedInboundUnit",
    sortName: "estimatedArrivalVolume",
    status: true,
    width: 120,
  },
  {
    cnName: "合格数量",
    enName: "qualified quantity",
    key: "qualifiedQuantity",
    status: true,
    width: 120,
  },
  {
    cnName: "不合格数量",
    enName: "unqualified quantity",
    key: "unqualifiedQuantity",
    status: true,
    width: 120,
  },
  {
    cnName: "上架数量",
    enName: "Number of shelves",
    key: "alreadyShelvedQuantity",
    sortName: "shelvedQuantity", // 需要添加别名的排序字段
    status: true,
    width: 120,
  },
  // {
  //   cnName: "是否API推送",
  //   enName: "Is API Push Enabled",
  //   key: "isAPPushOrder",
  //   status: true,
  //   width: 120,
  // },
  {
    cnName: "上架时间",
    enName: "date issued",
    key: "shelvingTime",
    sortName: "shelvesDate",
    status: true,
    width: 150,
  },
  {
    cnName: "时效",
    enName: "time efficiency",
    key: "express",
    status: true,
    width: 120,
  },
  {
    cnName: "上架及时率",
    enName: "On shelf rate",
    sortName: "completeRate",
    key: "onTimeRate",
    status: true,
    width: 120,
  },
  {
    cnName: "创建人",
    enName: "creator",
    key: "createUserName",
    status: true,
    width: 120,
  },
  {
    cnName: "创建时间",
    enName: "creation time",
    key: "createDate",
    // sortName: "a.createDate",
    status: true,
    width: 150,
  },
  {
    cnName: "提交时间",
    enName: "submission time",
    key: "submitTime",
    sortName: "confirmDate",
    status: true,
    width: 150,
  },
  {
    cnName: "收货时间",
    enName: "receiving time",
    key: "receiptTime",
    sortName: "receivingDate",
    status: true,
    width: 150,
  },
  {
    cnName: "备注",
    enName: "Remark",
    key: "remark",
    status: true,
    width: 200,
  },
  {
    cnName: "仓库备注",
    enName: "Warehouse note",
    key: "warehouseRemark",
    status: true,
    width: 120,
  },
  {
    cnName: "异常备注",
    enName: "Abnormal note",
    key: "abnormalRemarks",
    status: true,
    width: 120,
  },
];

// 客户端 - 库存SKU列表
let clientInventorySKUList = [
  {
    cnName: "缩略图",
    enName: "thumbnail",
    key: "goodsImage",
    status: true,
    width: 120,
  },
  {
    cnName: "库存SKU",
    enName: "inventorySKU",
    key: "sku",
    status: true,
    width: 120,
  },
  {
    cnName: "条码",
    enName: "bar code",
    key: "goodsCode",
    status: true,
    width: 120,
  },
  {
    cnName: "中文名称",
    enName: "Chinese name",
    key: "cnName",
    status: true,
    width: 120,
  },
  {
    cnName: "英文名称",
    enName: "English name",
    key: "enName",
    status: true,
    width: 120,
  },
  {
    cnName: "实际重量(KG)",
    enName: "actual weight KG",
    key: "realWeight",
    status: true,
    width: 120,
  },
  {
    cnName: "实际三边和(CM)",
    enName: "Actual Trilateral sum CM",
    key: "actualTrilateralSum", // 需要特殊处理的行可以自定义key
    status: true,
    width: 120,
  },
  {
    cnName: "实际尺寸(CM)",
    enName: "Actual size CM",
    key: "actualSize", // 需要特殊处理的行可以自定义key
    status: true,
    width: 120,
  },
  {
    cnName: "库存总量",
    enName: "inventory quantity",
    key: "totalInventory",
    status: true,
    width: 120,
  },
  {
    cnName: "占用库存总量",
    enName: "Total occupied inventory",
    key: "totalOccupiedInventory",
    status: true,
    width: 120,
  },
  {
    cnName: "不可用库存数量",
    enName: "quantity of disabled stock",
    key: "totalDisabledQuantity",
    status: true,
    width: 120,
  },
  {
    cnName: "库存总立方数(M³)",
    enName: "Total cubic number of inventory (M³)",
    key: "totalInventoryVolume",
    status: true,
    width: 120,
  },
  {
    cnName: "可用库存总量",
    enName: "Total available inventory",
    key: "totalUnshippedInventory",
    status: true,
    width: 120,
  },
  {
    cnName: "在途总立方数(M³)",
    enName: "Total number of cubes in transit (M³)",
    key: "totalInTransitVolume",
    status: true,
    width: 120,
  },
  {
    cnName: "在途库存总量",
    enName: "Total number in transit",
    key: "totalInTransitInventory",
    status: true,
    width: 120,
  },
  {
    cnName: "销量(7/14/30)",
    enName: "Sales Volume 7 14 30 60 90",
    key: "salesVolume71430", // 需要特殊处理的行可以自定义key
    status: true,
    width: 120,
  },
  {
    cnName: "销量(45/60/90)",
    enName: "Sales Volume 45 60 90",
    key: "salesVolume456090", // 需要特殊处理的行可以自定义key
    status: true,
    width: 120,
  },
  {
    cnName: "预测30天日均销量",
    enName: "Forecast 30 day average daily sales",
    key: "avg30Days",
    status: true,
    width: 120,
  },
  {
    cnName: "默认头程费",
    enName: "Default headway fee",
    key: "defaultFirstLegOrderUnitFee",
    status: true,
    width: 120,
  },
  {
    cnName: "采购价",
    enName: "purchase price",
    key: "costPrice",
    status: true,
    width: 120,
  },
  {
    cnName: "创建时间",
    enName: "creation time",
    key: "createTime",
    status: true,
    width: 120,
  },
  {
    cnName: "启用状态",
    enName: "initiate mode",
    key: "isActivity",
    status: true,
    width: 120,
  },
  {
    cnName: "商品计费属性",
    enName: "commodity billing attribute",
    key: "billingAttributes",
    status: true,
    width: 120,
  },
  {
    cnName: "质检信息状态",
    enName: "Quality inspection information status",
    key: "sizeToBeConfirmed",
    status: true,
    width: 120,
  },
  {
    cnName: "仓库：预警库存",
    enName: "warehouse: alert stock",
    key: "warehouseAlertStock",
    status: true,
    width: 120,
  },
  // 类目名称
  {
    langLabel: "Category_Name",
    key: "categoryName",
    status: true,
    width: 120,
  },
  // 品牌名称
  {
    langLabel: "Brand_Name",
    key: "brandName",
    status: true,
    width: 120,
  },
  // 销售状态
  {
    langLabel: "Sales_status",
    key: "salesStatus",
    status: true,
    width: 120,
  },
  // 自定义分类
  {
    langLabel: "Custom_classification",
    key: "customClassification",
    status: true,
    width: 120,
  },
  {
    cnName: "创建人",
    enName: "creator",
    key: "createUserName",
    status: true,
    width: 120,
  },
];

// 客户端 - 库存列表
let clientInventoryList = [
  {
    cnName: "缩略图",
    enName: "thumbnail",
    key: "goodsImage",
    status: true,
    width: 120,
  },
  {
    cnName: "商品条码",
    enName: "Bar code of goods",
    key: "goodsCode",
    status: true,
    width: 120,
  },
  {
    cnName: "sku",
    enName: "sku",
    key: "sku",
    status: true,
    width: 120,
  },
  {
    cnName: "商品中文名称",
    enName: "Goods Chinese name",
    key: "cnName",
    status: true,
    width: 120,
  },
  {
    cnName: "商品英文名称",
    enName: "Goods English name",
    key: "enName",
    status: true,
    width: 120,
  },
  {
    cnName: "仓库",
    enName: "warehouse",
    key: "stockId",
    status: true,
    width: 120,
  },
  {
    cnName: "库存类型",
    enName: "stock type",
    key: "tposStockType",
    status: true,
    width: 120,
  },
  {
    cnName: "库存数量",
    enName: "quantity in stock",
    key: "inventoryQuantity",
    status: true,
    width: 120,
  },
  {
    cnName: "总占用数量",
    enName: "total occupancy quantity",
    key: "occupationQuantity",
    status: true,
    width: 120,
  },
  {
    cnName: "不可用库存数量",
    enName: "quantity of disabled stock",
    key: "disabledQuantity",
    status: true,
    width: 120,
  },
  {
    cnName: "立方",
    enName: "cube",
    key: "volume",
    status: true,
    width: 120,
  },
  {
    cnName: "库存预警数量",
    enName: "Inventory warning quantity",
    key: "warnQuantity",
    status: true,
    width: 120,
  },
];

// 管理端 - 库存列表
let managementSideInventoryList = [
  {
    cnName: "商品图片",
    enName: "goods image",
    key: "goodsImage",
    status: true,
    width: 70,
  },
  {
    cnName: "客户ID",
    enName: "Customer ID",
    key: "customerId",
    status: true,
    width: 70,
  },
  {
    cnName: "商品条码",
    enName: "Bar code of goods",
    key: "goodsCode",
    status: true,
    width: 220,
  },
  {
    cnName: "sku",
    enName: "sku",
    key: "sku",
    status: true,
    width: 120,
  },
  {
    cnName: "商品中文名称",
    enName: "Goods Chinese name",
    key: "cnName",
    status: true,
    width: 120,
  },
  {
    cnName: "商品英文名称",
    enName: "Goods English name",
    key: "enName",
    status: true,
    width: 120,
  },
  {
    cnName: "仓库",
    enName: "warehouse",
    key: "stockId",
    status: true,
    width: 120,
  },
  {
    cnName: "库存类型",
    enName: "stock type",
    key: "tposStockType",
    status: true,
    width: 120,
  },
  {
    cnName: "库存数量",
    enName: "quantity in stock",
    key: "inventoryQuantity",
    status: true,
    width: 120,
  },
  {
    cnName: "总占用数量",
    enName: "total occupancy quantity",
    key: "occupationQuantity",
    status: true,
    width: 120,
  },
  {
    cnName: "不可用库存数量",
    enName: "quantity of disabled stock",
    key: "disabledQuantity",
    status: true,
    width: 120,
  },
  {
    cnName: "立方",
    enName: "cube",
    key: "volume",
    status: true,
    width: 120,
  },
  {
    cnName: "库存预警数量",
    enName: "Inventory warning quantity",
    key: "warnQuantity",
    status: true,
    width: 120,
  },
];

// 客户端 - 仓储订单列表
let clientInventoryOrderList = [
  {
    cnName: "平台",
    enName: "platform",
    key: "platformStyle",
    status: true,
    width: 120,
  },
  {
    cnName: "店铺",
    enName: "shop",
    key: "storeName",
    status: true,
    width: 120,
  },
  {
    cnName: "订单号",
    enName: "order number",
    key: "orderNo",
    status: true,
    width: 120,
  },
  {
    cnName: "交易号",
    enName: "transaction number",
    key: "csRefNo",
    status: true,
    width: 120,
  },
  {
    cnName: "运单号",
    enName: "waybill number",
    key: "trackingNo",
    status: true,
    width: 120,
  },
  {
    cnName: "平台物流渠道",
    enName: "Platform logistics channel",
    key: "cnNameType",
    status: true,
    width: 120,
  },
  {
    cnName: "平台状态",
    enName: "Platform state",
    key: "platformStatus",
    status: true,
    width: 120,
  },
  {
    cnName: "sku",
    enName: "sku",
    key: "sku",
    status: true,
    width: 120,
  },
  {
    cnName: "WMS状态",
    enName: "WMS status",
    key: "wmsStatus",
    status: true,
    width: 120,
  },
  {
    cnName: "送货方式",
    enName: "shipping method",
    key: "firstShipType",
    status: true,
    width: 120,
  },
  {
    cnName: "目的国家",
    enName: "destination country",
    key: "countryId",
    status: true,
    width: 120,
  },
  {
    cnName: "仓库",
    enName: "warehouse",
    key: "stockId",
    status: true,
    width: 120,
  },
  {
    cnName: "排除提交规则",
    enName: "Excluded submission rules",
    key: "clearRules",
    status: true,
    width: 120,
  },
  {
    cnName: "排除自动包材规则",
    enName: "Excluded automatic packaging rules",
    key: "clearPackagingRule",
    status: true,
    width: 120,
  },
  {
    cnName: "订单金额",
    enName: "order amount",
    key: "price",
    status: true,
    width: 120,
  },
  // {
  //   cnName: "交运异常信息",
  //   enName: "Delivery of abnormal information",
  //   key: "transEnron",
  //   status: true,
  //   width: 120,
  // },
  {
    cnName: "包材信息",
    enName: "Packaging material information",
    key: "orderPackagList",
    status: true,
    width: 200,
  },
  {
    cnName: "剩余发货时间",
    enName: "Remaining delivery time",
    key: "deliveryTime",
    status: true,
    width: 120,
  },
  {
    cnName: "创建时间",
    enName: "creation time",
    key: "createTime",
    status: true,
    width: 120,
  },
  {
    cnName: "确认时间",
    enName: "verify the time",
    key: "confirmTime",
    status: true,
    width: 120,
  },
  {
    cnName: "出库时间",
    enName: "delivery time",
    key: "deliveryTime",
    status: true,
    width: 120,
  },
  {
    cnName: "平台备注",
    enName: "Platform remarks",
    key: "platformRemark",
    status: true,
    width: 120,
  },
  {
    cnName: "备注",
    enName: "Remark",
    key: "cusRemark",
    status: true,
    width: 120,
  },
];

// 客户端 - 仓储全部订单列表
let clientInventoryAllOrderList = [
  {
    cnName: "平台",
    enName: "platform",
    key: "platformStyle",
    status: true,
    width: 120,
  },
  {
    cnName: "店铺",
    enName: "shop",
    key: "storeName",
    status: true,
    width: 120,
  },
  {
    cnName: "订单号",
    enName: "order number",
    key: "orderNo",
    status: true,
    width: 120,
  },
  {
    cnName: "交易号",
    enName: "transaction number",
    key: "csRefNo",
    status: true,
    width: 120,
  },
  {
    cnName: "运单号",
    enName: "waybill number",
    key: "trackingNo",
    status: true,
    width: 120,
  },
  {
    cnName: "平台物流渠道",
    enName: "Platform logistics channel",
    key: "cnNameType",
    status: true,
    width: 120,
  },
  {
    cnName: "平台状态",
    enName: "Platform state",
    key: "platformStatus",
    status: true,
    width: 120,
  },
  {
    cnName: "sku",
    enName: "sku",
    key: "sku",
    status: true,
    width: 120,
  },
  {
    cnName: "WMS状态",
    enName: "WMS status",
    key: "wmsStatus",
    status: true,
    width: 120,
  },
  {
    cnName: "送货方式",
    enName: "shipping method",
    key: "firstShipType",
    status: true,
    width: 120,
  },
  {
    cnName: "目的国家",
    enName: "destination country",
    key: "countryId",
    status: true,
    width: 120,
  },
  {
    cnName: "仓库",
    enName: "warehouse",
    key: "stockId",
    status: true,
    width: 120,
  },
  {
    cnName: "排除提交规则",
    enName: "Excluded submission rules",
    key: "clearRules",
    status: true,
    width: 120,
  },
  {
    cnName: "排除自动包材规则",
    enName: "Excluded automatic packaging rules",
    key: "clearPackagingRule",
    status: true,
    width: 120,
  },
  {
    cnName: "订单金额",
    enName: "order amount",
    key: "price",
    status: true,
    width: 120,
  },
  // {
  //   cnName: "交运异常信息",
  //   enName: "Delivery of abnormal information",
  //   key: "transEnron",
  //   status: true,
  //   width: 120,
  // },
  {
    cnName: "包材信息",
    enName: "Packaging material information",
    key: "orderPackagList",
    status: true,
    width: 200,
  },
  {
    cnName: "剩余发货时间",
    enName: "Remaining delivery time",
    key: "deliveryTime",
    status: true,
    width: 120,
  },
  {
    cnName: "创建时间",
    enName: "creation time",
    key: "createTime",
    status: true,
    width: 120,
  },
  {
    cnName: "确认时间",
    enName: "verify the time",
    key: "confirmTime",
    status: true,
    width: 120,
  },
  {
    cnName: "出库时间",
    enName: "delivery time",
    key: "deliveryTime",
    status: true,
    width: 120,
  },
  {
    cnName: "平台备注",
    enName: "Platform remarks",
    key: "platformRemark",
    status: true,
    width: 120,
  },
  {
    cnName: "备注",
    enName: "Remark",
    key: "cusRemark",
    status: true,
    width: 120,
  },
];
// 客户端 - 取消订单列表
let clientCancellationOrder = [
  {
    cnName: "平台",
    enName: "platform",
    key: "platformStyle",
    status: true,
    width: 120,
  },
  {
    cnName: "店铺",
    enName: "shop",
    key: "storeName",
    status: true,
    width: 120,
  },
  {
    cnName: "订单号",
    enName: "order number",
    key: "orderNo",
    status: true,
    width: 120,
  },
  {
    cnName: "交易号",
    enName: "transaction number",
    key: "csRefNo",
    status: true,
    width: 120,
  },
  {
    cnName: "运单号",
    enName: "waybill number",
    key: "trackingNo",
    status: true,
    width: 120,
  },
  {
    cnName: "平台物流渠道",
    enName: "Platform logistics channel",
    key: "cnNameType",
    status: true,
    width: 120,
  },
  {
    cnName: "平台状态",
    enName: "Platform state",
    key: "platformStatus",
    status: true,
    width: 120,
  },
  {
    cnName: "sku",
    enName: "sku",
    key: "sku",
    status: true,
    width: 120,
  },
  {
    cnName: "WMS状态",
    enName: "WMS status",
    key: "wmsStatus",
    status: true,
    width: 120,
  },
  {
    cnName: "送货方式",
    enName: "shipping method",
    key: "firstShipType",
    status: true,
    width: 120,
  },
  {
    cnName: "目的国家",
    enName: "destination country",
    key: "countryId",
    status: true,
    width: 120,
  },
  {
    cnName: "仓库",
    enName: "warehouse",
    key: "stockId",
    status: true,
    width: 120,
  },
  // {
  //   cnName: "排除提交规则",
  //   enName: "Excluded submission rules",
  //   key: "clearRules",
  //   status: true,
  //   width: 120,
  // },
  // {
  //   cnName: "排除自动包材规则",
  //   enName: "Excluded automatic packaging rules",
  //   key: "isClearAutoPacking",
  //   status: true,
  //   width: 120,
  // },
  {
    cnName: "订单金额",
    enName: "order amount",
    key: "price",
    status: true,
    width: 120,
  },
  // {
  //   cnName: "交运异常信息",
  //   enName: "Delivery of abnormal information",
  //   key: "transEnron",
  //   status: true,
  //   width: 120,
  // },
  // {
  //   cnName: "包材信息",
  //   enName: "Packaging material information",
  //   key: "orderPackagList",
  //   status: true,
  //   width: 200,
  // },
  {
    cnName: "剩余发货时间",
    enName: "Remaining delivery time",
    key: "deliveryTime",
    status: true,
    width: 120,
  },
  {
    cnName: "创建时间",
    enName: "creation time",
    key: "createTime",
    status: true,
    width: 120,
  },
  {
    cnName: "确认时间",
    enName: "verify the time",
    key: "confirmTime",
    status: true,
    width: 120,
  },
  {
    cnName: "出库时间",
    enName: "delivery time",
    key: "deliveryTime",
    status: true,
    width: 120,
  },
  // {
  //   cnName: "申请取消时间",
  //   enName: "Application cancellation time",
  //   key: "applicationCancelTime",
  //   status: true,
  //   width: 120,
  // },
  // {
  //   cnName: "过期时间",
  //   enName: "Expiration time",
  //   key: "expirationTime",
  //   status: true,
  //   width: 120,
  // },
  {
    cnName: "平台备注",
    enName: "Platform remarks",
    key: "platformRemark",
    status: true,
    width: 120,
  },
  {
    cnName: "备注",
    enName: "Remark",
    key: "cusRemark",
    status: true,
    width: 120,
  },
];
// 客户端 - 订单--异常交运列表
let abnormalInventoryOrderist = [
  {
    cnName: "平台",
    enName: "platform",
    key: "platformStyle",
    status: true,
    width: 120,
  },
  {
    cnName: "店铺",
    enName: "shop",
    key: "storeName",
    status: true,
    width: 120,
  },
  {
    cnName: "订单号",
    enName: "order number",
    key: "orderNo",
    status: true,
    width: 120,
  },
  {
    cnName: "交易号",
    enName: "transaction number",
    key: "csRefNo",
    status: true,
    width: 120,
  },
  {
    cnName: "运单号",
    enName: "waybill number",
    key: "trackingNo",
    status: true,
    width: 120,
  },
  {
    cnName: "平台物流渠道",
    enName: "Platform logistics channel",
    key: "cnNameType",
    status: true,
    width: 120,
  },
  {
    cnName: "平台状态",
    enName: "Platform state",
    key: "platformStatus",
    status: true,
    width: 120,
  },
  {
    cnName: "sku",
    enName: "sku",
    key: "sku",
    status: true,
    width: 120,
  },
  {
    cnName: "WMS状态",
    enName: "WMS status",
    key: "wmsStatus",
    status: true,
    width: 120,
  },
  {
    cnName: "送货方式",
    enName: "shipping method",
    key: "firstShipType",
    status: true,
    width: 120,
  },
  {
    cnName: "目的国家",
    enName: "destination country",
    key: "countryId",
    status: true,
    width: 120,
  },
  {
    cnName: "仓库",
    enName: "warehouse",
    key: "stockId",
    status: true,
    width: 120,
  },
  {
    cnName: "排除提交规则",
    enName: "Excluded submission rules",
    key: "clearRules",
    status: true,
    width: 120,
  },
  {
    cnName: "排除自动包材规则",
    enName: "Excluded automatic packaging rules",
    key: "clearPackagingRule",
    status: true,
    width: 120,
  },
  {
    cnName: "订单金额",
    enName: "order amount",
    key: "price",
    status: true,
    width: 120,
  },
  // {
  //   cnName: "交运异常信息",
  //   enName: "Delivery of abnormal information",
  //   key: "transEnron",
  //   status: true,
  //   width: 120,
  // },
  {
    cnName: "包材信息",
    enName: "Packaging material information",
    key: "orderPackagList",
    status: true,
    width: 200,
  },
  {
    cnName: "剩余发货时间",
    enName: "Remaining delivery time",
    key: "deliveryTime",
    status: true,
    width: 120,
  },
  {
    cnName: "创建时间",
    enName: "creation time",
    key: "createTime",
    status: true,
    width: 120,
  },
  {
    cnName: "确认时间",
    enName: "verify the time",
    key: "confirmTime",
    status: true,
    width: 120,
  },
  {
    cnName: "出库时间",
    enName: "delivery time",
    key: "deliveryTime",
    status: true,
    width: 120,
  },
  {
    cnName: "平台备注",
    enName: "Platform remarks",
    key: "platformRemark",
    status: true,
    width: 120,
  },
  {
    cnName: "备注",
    enName: "Remark",
    key: "cusRemark",
    status: true,
    width: 120,
  },
];

// 客户端 - 退货列表
let clientReturnList = [
  {
    cnName: "包裹图片",
    enName: "Package picture",
    key: "packageImage",
    status: true,
    width: 120,
  },
  {
    cnName: "客户ID",
    enName: "Customer ID",
    key: "customerId",
    status: true,
    width: 120,
  },
  {
    cnName: "运单号",
    enName: "waybill number",
    key: "trackingNo",
    status: true,
    width: 120,
  },
  {
    cnName: "处理方案",
    enName: "processing scheme",
    key: "treatment",
    status: true,
    width: 120,
  },
  {
    cnName: "交易号",
    enName: "transaction number",
    key: "csRefNo",
    status: true,
    width: 120,
  },
  {
    cnName: "订单号",
    enName: "order number",
    key: "orderNo",
    status: true,
    width: 120,
  },
  {
    cnName: "仓库",
    enName: "warehouse",
    key: "stockName",
    status: true,
    width: 120,
  },
  {
    cnName: "物流商",
    enName: "logistics provider",
    key: "logisticsProvider",
    status: true,
    width: 120,
  },
  {
    cnName: "平台",
    enName: "platform",
    key: "platformStyle",
    status: true,
    width: 120,
  },
  {
    cnName: "店铺",
    enName: "store",
    key: "storeName",
    status: true,
    width: 120,
  },
  {
    cnName: "创建时间",
    enName: "creation time",
    key: "createTime",
    status: true,
    width: 120,
  },
  {
    cnName: "上架时间",
    enName: "date issued",
    key: "groundTime",
    status: true,
    width: 120,
  },
  {
    cnName: "认领时间",
    enName: "Claim time",
    key: "claimTime",
    status: true,
    width: 120,
  },
  {
    cnName: "暂存号",
    enName: "Temporary storage number",
    key: "temporaryNo",
    status: true,
    width: 120,
  },
  {
    cnName: "备注",
    enName: "Remark",
    key: "remark",
    status: true,
    width: 120,
  },
];

// 客户端 - 查看包材
let clientPackagingMaterialManagement = [
  {
    cnName: "包材图片",
    enName: "Packaging material picture",
    key: "packagingImage",
    status: true,
    width: 120,
  },
  {
    cnName: "包材编码",
    enName: "Package material coding",
    key: "packagingCode",
    status: true,
    width: 120,
  },
  {
    cnName: "包材名称",
    enName: "Packing material name",
    key: "packagingName",
    status: true,
    width: 120,
  },
  {
    cnName: "包材长度(CM)",
    enName: "Packing material length (CM)",
    key: "packagingLength",
    status: true,
    width: 120,
  },
  {
    cnName: "包材宽度(CM)",
    enName: "Packing material width (CM)",
    key: "packagingWidth",
    status: true,
    width: 120,
  },
  {
    cnName: "包材高度(CM)",
    enName: "Packing material height (CM)",
    key: "packagingHeight",
    status: true,
    width: 120,
  },
  {
    cnName: "包材重量(KG)",
    enName: "Packing material Weight (KG)",
    key: "packagingWeight",
    status: true,
    width: 120,
  },
  {
    cnName: "包材数量",
    enName: "Packing material quantity",
    key: "packagingQuantity",
    status: true,
    width: 120,
  },
  {
    cnName: "单价",
    enName: "unit price",
    key: "unitPrice",
    status: true,
    width: 120,
  },
  {
    cnName: "包材类型",
    enName: "Packing material type",
    key: "packagingType",
    status: true,
    width: 120,
  },
  {
    cnName: "包材计费类型",
    enName: "Packing material billing type",
    key: "billingType",
    status: true,
    width: 120,
  },
  {
    cnName: "最低计费金额",
    enName: "Minimum charge amount",
    key: "billingMinMoney",
    status: true,
    width: 120,
  },
  {
    cnName: "预警数量",
    enName: "Number of warnings",
    key: "warningQuantity",
    status: true,
    width: 120,
  },
  {
    cnName: "仓库",
    enName: "warehouse",
    key: "stockId",
    status: true,
    width: 120,
  },
  {
    cnName: "启用状态",
    enName: "initiate mode",
    key: "isActive",
    status: true,
    width: 120,
  },
  {
    cnName: "创建人",
    enName: "founder",
    key: "createUserId",
    status: true,
    width: 120,
  },
  {
    cnName: "创建时间",
    enName: "creation time",
    key: "createTime",
    status: true,
    width: 120,
  },
];

// 管理端 - 头程订单列表
let managementFirstLegOrderList = [
  {
    cnName: "头程单号",
    enName: "FirstLegOrderNumber",
    key: "firstLegOrderNo",
    status: true,
    width: 120,
  },
  {
    cnName: "入库单号",
    enName: "warehouse entry number",
    key: "productEntryNo",
    status: true,
    width: 120,
  },
  {
    cnName: "客户ID",
    enName: "Customer ID",
    key: "customerId",
    status: true,
    width: 120,
  },
  {
    cnName: "目的仓库",
    enName: "Destination warehouse",
    key: "stockName",
    status: true,
    width: 120,
  },
  {
    cnName: "目的国家",
    enName: "destination country",
    key: "countryId",
    status: true,
    width: 120,
  },
  {
    cnName: "中转仓库",
    enName: "transshipmentdepot",
    key: "transitWarehouseId",
    status: true,
    width: 120,
  },
  {
    cnName: "商品货物属性",
    enName: "Commodity property",
    key: "productAttributeName",
    status: true,
    width: 120,
  },
  {
    cnName: "总申报价值(USD)",
    enName: "Total declared value(USD)",
    key: "sumUnitPrice",
    status: true,
    width: 120,
  },
  {
    cnName: "物流单号",
    enName: "tracking number",
    key: "containerNumber",
    status: true,
    width: 120,
  },
  {
    cnName: "交货方式",
    enName: "delivery type",
    key: "selfDeliveryOrCollection",
    status: true,
    width: 120,
  },
  {
    cnName: "总数量",
    enName: "total quantity",
    key: "totalQuantity",
    status: true,
    width: 120,
  },
  {
    cnName: "预约总重量(KG)",
    enName: "Reserved gross weight (KG)",
    key: "appointmentTotalWeight",
    status: true,
    width: 120,
  },
  {
    cnName: "预约总方数(M³)",
    enName: "Total number of reservations (M³)",
    key: "appointmentTotalVolume",
    status: true,
    width: 120,
  },
  {
    cnName: "预约总件数",
    enName: "Total number of appointments",
    key: "appointmentTotalPieces",
    status: true,
    width: 120,
  },
  {
    cnName: "实际总重量 (KG)",
    enName: "Actual gross weight (KG)",
    key: "actualTotalWeight",
    status: true,
    width: 120,
  },
  {
    cnName: "实际总方数 (M³)",
    enName: "Actual total number of squares (M³)",
    key: "actualTotalVolume",
    status: true,
    width: 120,
  },
  {
    cnName: "实际总件数",
    enName: "Total number of packages arrived",
    key: "arrivalTotalPieces",
    status: true,
    width: 120,
  },
  {
    cnName: "单号/货拉拉信息",
    enName: "odd Cargo pull information",
    key: "trackingInfo",
    status: true,
    width: 120,
  },
  {
    cnName: "装柜方式 / 装柜尺寸",
    enName: "Loading method / Loading size",
    key: "loadingMethodAndSize",
    status: true,
    width: 120,
  },
  {
    cnName: "运送到中转仓方式",
    enName: "Shipping to transit warehouse method",
    key: "transitToWarehouseMethod",
    status: true,
    width: 120,
  },
  {
    cnName: "中转仓收货时间",
    enName: "transit warehousereceiving time",
    key: "transferReceivedTime",
    status: true,
    width: 120,
  },
  {
    cnName: "渠道类型",
    enName: "Channel type",
    key: "channelType",
    status: true,
    width: 120,
  },
  // {
  //   cnName: "是否API推送",
  //   enName: "Is API Push Enabled",
  //   key: "isAPPushOrder",
  //   status: true,
  //   width: 120,
  // },
  {
    cnName: "客户备注",
    enName: "Customer remarks",
    key: "customerRemarks",
    status: true,
    width: 120,
  },
  {
    cnName: "客服备注",
    enName: "Customer service remarks",
    key: "serviceRemarks",
    status: true,
    width: 120,
  },
  {
    cnName: "仓库备注",
    enName: "Warehouse note",
    key: "receiveGoodsRemarks",
    status: true,
    width: 120,
  },
  {
    cnName: "异常备注",
    enName: "Abnormal remarks",
    key: "abnormalRemarks",
    status: true,
    width: 120,
  },
  {
    cnName: "承运时间",
    enName: "transit time",
    key: "transitTime",
    status: true,
    width: 120,
  },
  {
    cnName: "装载时间",
    enName: "loading time",
    key: "containerLoadingTime",
    status: true,
    width: 120,
  },
  {
    cnName: "预计到中转仓时间",
    enName: "Estimated time to transit warehouse",
    key: "estimatedArrivalTime",
    status: true,
    width: 120,
  },
  {
    cnName: "目的地到货时间",
    enName: "Destination arrival time",
    key: "destinationArrivalTime",
    status: true,
    width: 120,
  },
  {
    cnName: "提交时间",
    enName: "submission time",
    key: "submissionTime",
    status: true,
    width: 120,
  },
  {
    cnName: "创建时间",
    enName: "creation time",
    key: "createTime",
    // sortName: "a.createTime",
    status: true,
    width: 120,
  },
  {
    cnName: "创建人",
    enName: "creator",
    key: "createUserName",
    status: true,
    width: 120,
  },
];

// 管理端 - 头程账单列表
let managementFirstBillingList = [
  {
    cnName: "支付方式",
    enName: "payment type",
    key: "isPayment",
    status: true,
    width: 120,
  },
  {
    cnName: "头程订单号",
    enName: "First order number",
    key: "firstLegOrderNo",
    status: true,
    width: 120,
  },
  {
    cnName: "入库单单号",
    enName: "Entry number",
    key: "productEntryNo",
    status: true,
    width: 120,
  },
  {
    cnName: "客户ID",
    enName: "Customer ID",
    key: "customerId",
    status: true,
    width: 120,
  },
  {
    cnName: "目的仓库",
    enName: "Destination warehouse",
    key: "stockId",
    status: true,
    width: 120,
  },
  {
    cnName: "目的国家",
    enName: "destination country",
    key: "countryId",
    status: true,
    width: 120,
  },
  {
    cnName: "中转仓库",
    enName: "transshipmentdepot",
    key: "transitWarehouseId",
    status: true,
    width: 120,
  },
  {
    cnName: "实际总方数 (M³)",
    enName: "Actual total number of squares (M³)",
    key: "trueTotalCUBE",
    status: true,
    width: 120,
  },
  {
    cnName: "实际总重量 (KG)",
    enName: "Actual gross weight (KG)",
    key: "trueGrossWeight",
    status: true,
    width: 120,
  },
  {
    cnName: "计费总方数(M³)",
    enName: "Total number of billed squares (M³)",
    key: "actualTotalVolume",
    status: true,
    width: 120,
  },
  {
    cnName: "计费总重量 (KG)",
    enName: "Gross chargeable weight (KG)",
    key: "actualTotalWeight",
    status: true,
    width: 120,
  },
  {
    cnName: "实际总件数",
    enName: "Total number of packages arrived",
    key: "arrivalTotalPieces",
    status: true,
    width: 120,
  },
  {
    cnName: "流水号",
    enName: "Serial number",
    key: "serialNumber",
    status: true,
    width: 120,
  },
  {
    cnName: "结算单号",
    enName: "Statement number",
    key: "settlenumber",
    status: true,
    width: 120,
  },
  {
    cnName: "支付单号",
    enName: "Payment order number",
    key: "rechargeNumber",
    status: true,
    width: 120,
  },
  {
    cnName: "货物属性",
    enName: "Property of goods",
    key: "productAttributeName",
    status: true,
    width: 120,
  },
  {
    cnName: "装柜方式",
    enName: "loading method ",
    key: "stuffingTypeName",
    status: true,
    width: 120,
  },
  {
    cnName: "装柜尺寸",
    enName: "packing dimensions",
    key: "stuffingSizeName",
    status: true,
    width: 120,
  },
  {
    cnName: "总运费成本",
    enName: "Total freight cost",
    key: "totalFreightCost",
    status: true,
    width: 120,
  },
  {
    cnName: "总运费金额",
    enName: "Total freight",
    key: "totalFreightAmount",
    status: true,
    width: 120,
  },
  {
    cnName: "费用补扣金额",
    enName: "The amount of the deduction",
    key: "firstLegDeduction",
    status: true,
    width: 120,
  },
  {
    cnName: "总附加费",
    enName: "Gross surcharge",
    key: "totalSurcharge",
    status: true,
    width: 120,
  },
  {
    cnName: "总利润",
    enName: "gross profit",
    key: "totalProfit",
    status: true,
    width: 120,
  },
  {
    cnName: "渠道类型",
    enName: "Channel type",
    key: "channelType",
    status: true,
    width: 120,
  },
  {
    cnName: "物流单号",
    enName: "tracking number",
    key: "containerNumber",
    status: true,
    width: 120,
  },
  {
    cnName: "创建时间",
    enName: "creation time",
    key: "createTime",
    // sortName: "a.createTime",
    status: true,
    width: 120,
  },
  {
    cnName: "付款时间",
    enName: "time of payment",
    key: "paymentTime",
    status: true,
    width: 120,
  },
  {
    cnName: "结算时间",
    enName: "settlement date",
    key: "settleTime",
    status: true,
    width: 120,
  },
  {
    cnName: "财务核实时间",
    enName: "Financial verification time",
    key: "financeVerifyTime",
    status: true,
    width: 120,
  },
  {
    cnName: "核实收款时间",
    enName: "Verify collection time",
    key: "verifyCollectionTime",
    status: true,
    width: 120,
  },
  {
    cnName: "装载时间",
    enName: "loading time",
    key: "containerLoadingTime",
    status: true,
    width: 120,
  },
  {
    cnName: "客户备注",
    enName: "Customer remarks",
    key: "customerRemarks",
    status: true,
    width: 120,
  },
  {
    cnName: "客服备注",
    enName: "Customer service remarks",
    key: "serviceRemarks",
    status: true,
    width: 120,
  },
  {
    cnName: "财务备注",
    enName: "Financial remarks",
    key: "financeRemark",
    status: true,
    width: 120,
  },
  {
    cnName: "创建人",
    enName: "Creator",
    key: "createUserName",
    status: true,
    width: 120,
  },
];

// 管理端 - 入库单列表
let managementWarehouseEntryList = [
  {
    cnName: "入库单号",
    enName: "warehouse entry number",
    key: "productEntryNo",
    status: true,
    width: 220,
  },
  {
    cnName: "头程单号",
    enName: "FirstLegOrderNumber",
    key: "trackingNo",
    status: true,
    width: 220,
  },
  {
    cnName: "客户ID",
    enName: "Customer ID",
    key: "customerId",
    status: true,
    width: 220,
  },
  {
    cnName: "仓库",
    enName: "warehouse",
    key: "warehouse",
    status: true,
    width: 170,
  },
  {
    cnName: "箱数",
    enName: "box quantity",
    key: "boxCount",
    sortName: "boxQty",
    status: true,
    width: 170,
  },
  {
    cnName: "SKU数量",
    enName: "Number of SKUs",
    key: "skuCount",
    status: true,
    width: 170,
  },
  // {
  //   cnName: "是否API推送",
  //   enName: "Is API Push Enabled",
  //   key: "isAPPushOrder",
  //   status: true,
  //   width: 120,
  // },
  {
    cnName: "预计到达仓时间",
    enName: "Estimated time of arrival",
    key: "estimatedArrivalDate",
    status: true,
    width: 140,
  },
  {
    cnName: "预约入库数量",
    enName: "Quantity of reserved storage",
    key: "appointedInboundQuantity",
    sortName: "estimatedArrivalNum",
    status: true,
    width: 140,
  },
  {
    cnName: "预约入库方数",
    enName: "Number of reserved storage parties",
    key: "appointedInboundUnit",
    sortName: "estimatedArrivalVolume",
    status: true,
    width: 140,
  },
  {
    cnName: "合格数量",
    enName: "qualified quantity",
    key: "qualifiedQuantity",
    status: true,
    width: 100,
  },
  {
    cnName: "不合格数量",
    enName: "unqualified quantity",
    key: "unqualifiedQuantity",
    status: true,
    width: 100,
  },
  {
    cnName: "上架数量",
    enName: "Number of shelves",
    key: "alreadyShelvedQuantity",
    sortName: "shelvedQuantity",
    status: true,
    width: 100,
  },
  {
    cnName: "上架时间",
    enName: "date issued",
    key: "shelvingTime",
    sortName: "shelvesDate",
    status: true,
    width: 140,
  },
  {
    cnName: "时效",
    enName: "time efficiency",
    key: "express",
    status: true,
    width: 100,
  },
  {
    cnName: "上架及时率",
    enName: "On shelf rate",
    key: "onTimeRate",
    sortName: "completeRate",
    status: true,
    width: 100,
  },
  {
    cnName: "开始质检时间",
    enName: "Start quality control time",
    key: "beginCheckTime",
    status: true,
    width: 140,
  },
  {
    cnName: "结束质检时间",
    enName: "End quality control time",
    key: "endCheckTime",
    status: true,
    width: 140,
  },
  {
    cnName: "创建时间",
    enName: "creation time",
    key: "createDate",
    sortName: "createDate",
    status: true,
    width: 140,
  },
  {
    cnName: "提交时间",
    enName: "submission time",
    key: "submitTime",
    status: true,
    width: 140,
  },
  {
    cnName: "收货时间",
    enName: "receiving time",
    key: "receiptTime",
    sortName: "receivingDate",
    status: true,
    width: 140,
  },
  {
    cnName: "备注",
    enName: "remark",
    key: "remark",
    status: true,
    width: 120,
  },
  {
    cnName: "仓库备注",
    enName: "Warehouse note",
    key: "warehouseRemark",
    status: true,
    width: 120,
  },
  {
    cnName: "异常备注",
    enName: "Abnormal note",
    key: "abnormalRemarks",
    status: true,
    width: 120,
  },
  {
    cnName: "创建人",
    enName: "Creator",
    key: "createUserName",
    status: true,
    width: 120,
  },
];

// 管理端 - 入库单待收货列表
let managementWarehouseReceiptList = [
  {
    cnName: "入库单号",
    enName: "warehouse entry number",
    key: "productEntryNo",
    status: true,
    width: 210,
  },
  {
    cnName: "头程单号",
    enName: "FirstLegOrderNumber",
    key: "trackingNo",
    status: true,
    width: 210,
  },
  {
    cnName: "客户ID",
    enName: "Customer ID",
    key: "customerId",
    status: true,
    width: 210,
  },
  {
    cnName: "仓库",
    enName: "warehouse",
    key: "warehouse",
    status: true,
    width: 170,
  },
  {
    cnName: "箱数",
    enName: "box quantity",
    key: "boxCount",
    sortName: "boxQty",
    status: true,
    width: 170,
  },
  {
    cnName: "SKU数量",
    enName: "Number of SKUs",
    key: "skuCount",
    status: true,
    width: 170,
  },
  {
    cnName: "合格数量",
    enName: "qualified quantity",
    key: "qualifiedQuantity",
    status: true,
    width: 100,
  },
  {
    cnName: "不合格数量",
    enName: "unqualified quantity",
    key: "unqualifiedQuantity",
    status: true,
    width: 100,
  },
  {
    cnName: "上架数量",
    enName: "Number of shelves",
    key: "alreadyShelvedQuantity",
    sortName: "shelvedQuantity",
    status: true,
    width: 100,
  },
  {
    cnName: "预计到达仓时间",
    enName: "Estimated time of arrival",
    key: "estimatedArrivalDate",
    status: true,
    width: 140,
  },
  {
    cnName: "预约入库数量",
    enName: "Quantity of reserved storage",
    key: "appointedInboundQuantity",
    sortName: "estimatedArrivalNum",
    status: true,
    width: 140,
  },
  {
    cnName: "预约入库方数",
    enName: "Number of reserved storage parties",
    key: "appointedInboundUnit",
    sortName: "estimatedArrivalVolume",
    status: true,
    width: 140,
  },
  {
    cnName: "创建时间",
    enName: "creation time",
    key: "createDate",
    status: true,
    width: 140,
  },
  {
    cnName: "提交时间",
    enName: "submission time",
    key: "submitTime",
    status: true,
    width: 140,
  },
  {
    cnName: "收货时间",
    enName: "receiving time",
    key: "receiptTime",
    sortName: "receivingDate",
    status: true,
    width: 140,
  },
  {
    cnName: "上架时间",
    enName: "date issued",
    key: "shelvingTime",
    sortName: "shelvesDate",
    status: true,
    width: 100,
  },
  {
    cnName: "时效",
    enName: "time efficiency",
    key: "express",
    status: true,
    width: 100,
  },
  {
    cnName: "上架及时率",
    enName: "On shelf rate",
    key: "onTimeRate",
    sortName: "completeRate",
    status: true,
    width: 100,
  },
  {
    cnName: "备注",
    enName: "remark",
    key: "remark",
    status: true,
    width: 120,
  },
  {
    cnName: "仓库备注",
    enName: "Warehouse note",
    key: "warehouseRemark",
    status: true,
    width: 120,
  },
];

// 管理端 - 入库单待质检列表
let managementInventoryEntryListChecked = [
  {
    cnName: "入库单号",
    enName: "warehouse entry number",
    key: "productEntryNo",
    status: true,
    width: 210,
  },
  {
    cnName: "头程单号",
    enName: "FirstLegOrderNumber",
    key: "trackingNo",
    status: true,
    width: 210,
  },
  {
    cnName: "客户ID",
    enName: "Customer ID",
    key: "customerId",
    status: true,
    width: 210,
  },
  {
    cnName: "仓库",
    enName: "warehouse",
    key: "warehouse",
    status: true,
    width: 170,
  },
  {
    cnName: "箱数",
    enName: "box quantity",
    key: "boxCount",
    sortName: "boxQty",
    status: true,
    width: 170,
  },
  {
    cnName: "SKU数量",
    enName: "Number of SKUs",
    key: "skuCount",
    status: true,
    width: 170,
  },
  {
    cnName: "合格数量",
    enName: "qualified quantity",
    key: "qualifiedQuantity",
    status: true,
    width: 100,
  },
  {
    cnName: "不合格数量",
    enName: "unqualified quantity",
    key: "unqualifiedQuantity",
    status: true,
    width: 100,
  },
  {
    cnName: "上架数量",
    enName: "Number of shelves",
    key: "alreadyShelvedQuantity",
    sortName: "shelvedQuantity",
    status: true,
    width: 100,
  },
  {
    cnName: "预计到达仓时间",
    enName: "Estimated time of arrival",
    key: "estimatedArrivalDate",
    status: true,
    width: 140,
  },
  {
    cnName: "预约入库数量",
    enName: "Quantity of reserved storage",
    key: "appointedInboundQuantity",
    sortName: "estimatedArrivalNum",
    status: true,
    width: 140,
  },
  {
    cnName: "预约入库方数",
    enName: "Number of reserved storage parties",
    key: "appointedInboundUnit",
    sortName: "estimatedArrivalVolume",
    status: true,
    width: 140,
  },
  {
    cnName: "创建时间",
    enName: "creation time",
    key: "createDate",
    status: true,
    width: 140,
  },
  {
    cnName: "提交时间",
    enName: "submission time",
    key: "submitTime",
    status: true,
    width: 140,
  },
  {
    cnName: "收货时间",
    enName: "receiving time",
    key: "receiptTime",
    sortName: "receivingDate",
    status: true,
    width: 140,
  },
  {
    cnName: "上架时间",
    enName: "date issued",
    key: "shelvingTime",
    sortName: "shelvesDate",
    status: true,
    width: 100,
  },
  {
    cnName: "时效",
    enName: "time efficiency",
    key: "express",
    status: true,
    width: 100,
  },
  {
    cnName: "上架及时率",
    enName: "On shelf rate",
    key: "onTimeRate",
    sortName: "completeRate",
    status: true,
    width: 100,
  },
  {
    cnName: "备注",
    enName: "remark",
    key: "remark",
    status: true,
    width: 120,
  },
  {
    cnName: "仓库备注",
    enName: "Warehouse note",
    key: "warehouseRemark",
    status: true,
    width: 120,
  },
];

// 管理端 - 入库单待上架列表
let managementInventoryEntryList = [
  {
    cnName: "入库单号",
    enName: "warehouse entry number",
    key: "productEntryNo",
    status: true,
    width: 210,
  },
  {
    cnName: "头程单号",
    enName: "FirstLegOrderNumber",
    key: "trackingNo",
    status: true,
    width: 210,
  },
  {
    cnName: "客户ID",
    enName: "Customer ID",
    key: "customerId",
    status: true,
    width: 210,
  },
  {
    cnName: "仓库",
    enName: "warehouse",
    key: "warehouse",
    status: true,
    width: 170,
  },
  {
    cnName: "箱数",
    enName: "box quantity",
    key: "boxCount",
    sortName: "boxQty",
    status: true,
    width: 170,
  },
  {
    cnName: "SKU数量",
    enName: "Number of SKUs",
    key: "skuCount",
    status: true,
    width: 170,
  },
  {
    cnName: "合格数量",
    enName: "qualified quantity",
    key: "qualifiedQuantity",
    status: true,
    width: 100,
  },
  {
    cnName: "不合格数量",
    enName: "unqualified quantity",
    key: "unqualifiedQuantity",
    status: true,
    width: 100,
  },
  {
    cnName: "上架数量",
    enName: "Number of shelves",
    key: "alreadyShelvedQuantity",
    sortName: "shelvedQuantity",
    status: true,
    width: 100,
  },
  {
    cnName: "预计到达仓时间",
    enName: "Estimated time of arrival",
    key: "estimatedArrivalDate",
    status: true,
    width: 140,
  },
  {
    cnName: "预约入库数量",
    enName: "Quantity of reserved storage",
    key: "appointedInboundQuantity",
    sortName: "estimatedArrivalNum",
    status: true,
    width: 140,
  },
  {
    cnName: "预约入库方数",
    enName: "Number of reserved storage parties",
    key: "appointedInboundUnit",
    sortName: "estimatedArrivalVolume",
    status: true,
    width: 140,
  },
  {
    cnName: "创建时间",
    enName: "creation time",
    key: "createDate",
    status: true,
    width: 140,
  },
  {
    cnName: "提交时间",
    enName: "submission time",
    key: "submitTime",
    status: true,
    width: 140,
  },
  {
    cnName: "收货时间",
    enName: "receiving time",
    key: "receiptTime",
    sortName: "receivingDate",
    status: true,
    width: 140,
  },
  {
    cnName: "上架时间",
    enName: "date issued",
    key: "shelvingTime",
    sortName: "shelvesDate",
    status: true,
    width: 100,
  },
  {
    cnName: "时效",
    enName: "time efficiency",
    key: "express",
    status: true,
    width: 100,
  },
  {
    cnName: "上架及时率",
    enName: "On shelf rate",
    key: "onTimeRate",
    sortName: "completeRate",
    status: true,
    width: 100,
  },
  {
    cnName: "备注",
    enName: "remark",
    key: "remark",
    status: true,
    width: 120,
  },
  {
    cnName: "仓库备注",
    enName: "Warehouse note",
    key: "warehouseRemark",
    status: true,
    width: 120,
  },
];

// 管理端 - 库存SKU列表
let managementInventorySKUList = [
  {
    cnName: "缩略图",
    enName: "thumbnail",
    key: "goodsImage",
    status: true,
    width: 60,
  },
  {
    cnName: "客户ID",
    enName: "Customer ID",
    langLabel: "Customer_ID",
    key: "customerId",
    status: true,
    width: 220,
  },
  {
    cnName: "SKU",
    enName: "sku",
    key: "sku",
    status: true,
    width: 220,
  },
  {
    cnName: "商品条码",
    enName: "Bar code of goods",
    key: "goodsCode",
    status: true,
    width: 220,
  },
  {
    cnName: "中文名称",
    enName: "Chinese name",
    key: "cnName",
    status: true,
    width: 120,
  },
  {
    cnName: "英文名称",
    enName: "English name",
    key: "enName",
    status: true,
    width: 120,
  },
  {
    cnName: "实际重量(KG)",
    enName: "actual weight KG",
    key: "realWeight",
    status: true,
    width: 110,
  },
  {
    cnName: "实际三边和(CM)",
    enName: "Actual Trilateral sum CM",
    key: "actualTrilateralSum", // 需要特殊处理的行可以自定义key
    status: true,
    width: 110,
  },
  {
    cnName: "实际尺寸(CM)",
    enName: "Actual size CM",
    key: "actualSize", // 需要特殊处理的行可以自定义key
    status: true,
    width: 110,
  },
  {
    cnName: "库存总量",
    enName: "inventory quantity",
    key: "totalInventory",
    status: true,
    width: 100,
  },
  {
    cnName: "占用库存总量",
    enName: "Total occupied inventory",
    key: "totalOccupiedInventory",
    status: true,
    width: 100,
  },
  {
    cnName: "不可用库存数量",
    enName: "quantity of disabled stock",
    key: "totalDisabledQuantity",
    status: true,
    width: 120,
  },
  {
    cnName: "可用库存总量",
    enName: "Total available inventory",
    key: "totalUnshippedInventory",
    status: true,
    width: 120,
  },
  {
    cnName: "退货处理中库存",
    enName: "Inventory in return processing",
    key: "returnOrderInventory",
    status: true,
    width: 120,
  },
  {
    cnName: "库存总立方数(M³)",
    enName: "Total cubic number of inventory (M³)",
    key: "totalInventoryVolume",
    status: true,
    width: 120,
  },

  {
    cnName: "在途总立方数(M³)",
    enName: "Total number of cubes in transit (M³)",
    key: "totalInTransitVolume",
    status: true,
    width: 120,
  },
  {
    cnName: "在途库存总量",
    enName: "Total number in transit",
    key: "totalInTransitInventory",
    status: true,
    width: 120,
  },
  {
    cnName: "销量(7/14/30)",
    enName: "Sales Volume 7 14 30 60 90",
    key: "salesVolume71430", // 需要特殊处理的行可以自定义key
    status: true,
    width: 110,
  },
  {
    cnName: "销量(45/60/90)",
    enName: "Sales Volume 45 60 90",
    key: "salesVolume456090", // 需要特殊处理的行可以自定义key
    status: true,
    width: 110,
  },
  {
    cnName: "预测30天日均销量",
    enName: "Forecast 30 day average daily sales",
    key: "avg30Days",
    status: true,
    width: 110,
  },
  {
    cnName: "可贴单出库仓库",
    enName: "can be posted to the outbound warehouse",
    key: "productMarking",
    status: true,
    width: 100,
  },
  {
    cnName: "质检信息状态",
    enName: "Quality inspection information status",
    key: "sizeToBeConfirmed",
    status: true,
    width: 100,
  },
  {
    cnName: "采购价(RMB)",
    enName: "purchase price (RMB)",
    key: "costPrice",
    status: true,
    width: 95,
  },
  {
    cnName: "默认头程费",
    enName: "Default headway fee",
    key: "defaultFirstLegOrderUnitFee",
    status: true,
    width: 95,
  },
  {
    cnName: "商品计费属性",
    enName: "commodity billing attribute",
    key: "billingAttributes",
    status: true,
    width: 95,
  },
  {
    cnName: "启用状态",
    enName: "initiate mode",
    key: "isActivity",
    status: true,
    width: 140,
  },
  {
    cnName: "是否可编辑",
    enName: "Whether it is editable",
    key: "isReal",
    status: true,
    width: 140,
  },
  {
    cnName: "创建时间",
    enName: "creation time",
    key: "createTime",
    status: true,
    width: 120,
  },
  {
    cnName: "创建人",
    enName: "Creator",
    key: "createUserName",
    status: true,
    width: 120,
  },
  // {
  //   cnName: "仓库：预警数量",
  //   enName: "Warehouse: Number of warnings",
  //   key: "productInventoryWarningList",
  //   status: true,
  //   width: 120,
  // },
];

// 管理端 - 仓储订单列表
let managementInventoryOrderList = [
  {
    cnName: "客户ID",
    enName: "Customer ID",
    key: "customerId",
    status: true,
    width: 120,
  },
  {
    cnName: "平台",
    enName: "platform",
    key: "platformStyle",
    status: true,
    width: 120,
  },
  {
    cnName: "店铺",
    enName: "shop",
    key: "storeName",
    status: true,
    width: 120,
  },
  {
    cnName: "订单号",
    enName: "order number",
    key: "orderNo",
    status: true,
    width: 120,
  },
  {
    cnName: "交易号",
    enName: "transaction number",
    key: "csRefNo",
    status: true,
    width: 120,
  },
  {
    cnName: "运单号",
    enName: "waybill number",
    key: "trackingNo",
    status: true,
    width: 120,
  },
  {
    cnName: "平台物流渠道",
    enName: "Platform logistics channel",
    key: "labelType",
    status: true,
    width: 120,
  },
  {
    cnName: "平台状态",
    enName: "Platform state",
    key: "platformStatus",
    status: true,
    width: 120,
  },
  {
    cnName: "sku",
    enName: "sku",
    key: "sku",
    status: true,
    width: 120,
  },
  {
    cnName: "WMS状态",
    enName: "WMS status",
    key: "wmsStatus",
    status: true,
    width: 120,
  },
  {
    cnName: "送货方式",
    enName: "shipping method",
    key: "firstShipType",
    status: true,
    width: 120,
  },
  {
    cnName: "下发状态",
    enName: "Issued Status",
    key: "dispatchStatus",
    status: true,
    width: 120,
  },
  {
    cnName: "订单来源",
    enName: "order source",
    key: "orderType",
    status: true,
    width: 120,
  },
  {
    cnName: "目的国家",
    enName: "destination country",
    key: "countryId",
    status: true,
    width: 120,
  },
  {
    cnName: "仓库",
    enName: "warehouse",
    key: "stockId",
    status: true,
    width: 120,
  },
  {
    cnName: "任务ID",
    enName: "taskID",
    key: "orderFulfillmentTaskId",
    status: true,
    width: 120,
  },
  {
    cnName: "订单金额",
    enName: "order amount",
    key: "price",
    status: true,
    width: 120,
  },
  // {
  //   cnName: "交运异常信息",
  //   enName: "Delivery of abnormal information",
  //   key: "transEnron",
  //   status: true,
  //   width: 120,
  // },
  {
    cnName: "包材信息",
    enName: "Packaging material information",
    key: "orderPackagList",
    status: true,
    width: 200,
  },
  {
    cnName: "剩余发货时间",
    enName: "Remaining delivery time",
    key: "deliveryTime",
    status: true,
    width: 120,
  },
  {
    cnName: "创建时间",
    enName: "creation time",
    key: "createTime",
    status: true,
    width: 120,
  },
  {
    cnName: "确认时间",
    enName: "verify the time",
    key: "confirmTime",
    status: true,
    width: 120,
  },
  {
    cnName: "出库时间",
    enName: "delivery time",
    key: "deliveryTime",
    status: true,
    width: 120,
  },
  {
    cnName: "平台备注",
    enName: "Platform remarks",
    key: "platformRemark",
    status: true,
    width: 120,
  },
  {
    cnName: "客户备注",
    enName: "Customer remarks",
    key: "cusRemark",
    status: true,
    width: 120,
  },
  {
    cnName: "仓库备注",
    enName: "Warehouse note",
    key: "remark",
    status: true,
    width: 120,
  },
];

// 管理端 - 仓储订单(全部)列表
let managementInventoryAllOrderList = [
  {
    cnName: "客户ID",
    enName: "Customer ID",
    key: "customerId",
    status: true,
    width: 120,
  },
  {
    cnName: "平台",
    enName: "platform",
    key: "platformStyle",
    status: true,
    width: 120,
  },
  {
    cnName: "店铺",
    enName: "shop",
    key: "storeName",
    status: true,
    width: 120,
  },
  {
    cnName: "订单号",
    enName: "order number",
    key: "orderNo",
    status: true,
    width: 120,
  },
  {
    cnName: "交易号",
    enName: "transaction number",
    key: "csRefNo",
    status: true,
    width: 120,
  },
  {
    cnName: "运单号",
    enName: "waybill number",
    key: "trackingNo",
    status: true,
    width: 120,
  },
  {
    cnName: "平台物流渠道",
    enName: "Platform logistics channel",
    key: "labelType",
    status: true,
    width: 120,
  },
  {
    cnName: "平台状态",
    enName: "Platform state",
    key: "platformStatus",
    status: true,
    width: 120,
  },
  {
    cnName: "sku",
    enName: "sku",
    key: "sku",
    status: true,
    width: 120,
  },
  {
    cnName: "WMS状态",
    enName: "WMS status",
    key: "wmsStatus",
    status: true,
    width: 120,
  },
  {
    cnName: "送货方式",
    enName: "shipping method",
    key: "firstShipType",
    status: true,
    width: 120,
  },
  {
    cnName: "订单来源",
    enName: "order source",
    key: "orderType",
    status: true,
    width: 120,
  },
  {
    cnName: "目的国家",
    enName: "destination country",
    key: "countryId",
    status: true,
    width: 120,
  },
  {
    cnName: "仓库",
    enName: "warehouse",
    key: "stockId",
    status: true,
    width: 120,
  },
  {
    cnName: "任务ID",
    enName: "taskID",
    key: "orderFulfillmentTaskId",
    status: true,
    width: 120,
  },
  {
    cnName: "订单金额",
    enName: "order amount",
    key: "price",
    status: true,
    width: 120,
  },
  // {
  //   cnName: "交运异常信息",
  //   enName: "Delivery of abnormal information",
  //   key: "transEnron",
  //   status: true,
  //   width: 120,
  // },
  {
    cnName: "包材信息",
    enName: "Packaging material information",
    key: "orderPackagList",
    status: true,
    width: 200,
  },
  {
    cnName: "剩余发货时间",
    enName: "Remaining delivery time",
    key: "deliveryTime",
    status: true,
    width: 120,
  },
  {
    cnName: "创建时间",
    enName: "creation time",
    key: "createTime",
    status: true,
    width: 120,
  },
  {
    cnName: "确认时间",
    enName: "verify the time",
    key: "confirmTime",
    status: true,
    width: 120,
  },
  {
    cnName: "出库时间",
    enName: "delivery time",
    key: "deliveryTime",
    status: true,
    width: 120,
  },
  {
    cnName: "平台备注",
    enName: "Platform remarks",
    key: "platformRemark",
    status: true,
    width: 120,
  },
  {
    cnName: "客户备注",
    enName: "Customer remarks",
    key: "cusRemark",
    status: true,
    width: 120,
  },
  {
    cnName: "仓库备注",
    enName: "Warehouse note",
    key: "remark",
    status: true,
    width: 120,
  },
];
// 管理端 - 取消订单列表
let cancellationOrderList = [
  {
    cnName: "客户ID",
    enName: "Customer ID",
    key: "customerId",
    status: true,
    width: 120,
  },
  {
    cnName: "平台",
    enName: "platform",
    key: "platformStyle",
    status: true,
    width: 120,
  },
  {
    cnName: "店铺",
    enName: "shop",
    key: "storeName",
    status: true,
    width: 120,
  },
  {
    cnName: "订单号",
    enName: "order number",
    key: "orderNo",
    status: true,
    width: 120,
  },
  {
    cnName: "交易号",
    enName: "transaction number",
    key: "csRefNo",
    status: true,
    width: 120,
  },
  {
    cnName: "运单号",
    enName: "waybill number",
    key: "trackingNo",
    status: true,
    width: 120,
  },
  {
    cnName: "平台物流渠道",
    enName: "Platform logistics channel",
    key: "labelType",
    status: true,
    width: 120,
  },
  {
    cnName: "平台状态",
    enName: "Platform state",
    key: "platformStatus",
    status: true,
    width: 120,
  },
  {
    cnName: "sku",
    enName: "sku",
    key: "sku",
    status: true,
    width: 120,
  },
  {
    cnName: "WMS状态",
    enName: "WMS status",
    key: "wmsStatus",
    status: true,
    width: 120,
  },
  {
    cnName: "送货方式",
    enName: "shipping method",
    key: "firstShipType",
    status: true,
    width: 120,
  },
  {
    cnName: "订单来源",
    enName: "order source",
    key: "orderType",
    status: true,
    width: 120,
  },
  {
    cnName: "目的国家",
    enName: "destination country",
    key: "countryId",
    status: true,
    width: 120,
  },
  {
    cnName: "仓库",
    enName: "warehouse",
    key: "stockId",
    status: true,
    width: 120,
  },
  {
    cnName: "任务ID",
    enName: "taskID",
    key: "orderFulfillmentTaskId",
    status: true,
    width: 120,
  },
  {
    cnName: "订单金额",
    enName: "order amount",
    key: "price",
    status: true,
    width: 120,
  },
  // {
  //   cnName: "交运异常信息",
  //   enName: "Delivery of abnormal information",
  //   key: "transEnron",
  //   status: true,
  //   width: 120,
  // },
  // {
  //   cnName: "包材信息",
  //   enName: "Packaging material information",
  //   key: "orderPackagList",
  //   status: true,
  //   width: 200,
  // },
  {
    cnName: "创建时间",
    enName: "creation time",
    key: "createTime",
    status: true,
    width: 120,
  },
  {
    cnName: "确认时间",
    enName: "verify the time",
    key: "confirmTime",
    status: true,
    width: 120,
  },
  {
    cnName: "出库时间",
    enName: "delivery time",
    key: "deliveryTime",
    status: true,
    width: 120,
  },
  {
    cnName: "平台备注",
    enName: "Platform remarks",
    key: "platformRemark",
    status: true,
    width: 120,
  },
  {
    cnName: "客户备注",
    enName: "Customer remarks",
    key: "cusRemark",
    status: true,
    width: 120,
  },
  {
    cnName: "仓库备注",
    enName: "Warehouse note",
    key: "remark",
    status: true,
    width: 120,
  },
];

// 管理端 - 任务列表
let managementTaskList = [
  {
    cnName: "仓库",
    enName: "warehouse",
    key: "stockId",
    status: true,
    width: 120,
  },
  {
    cnName: "任务ID",
    enName: "orderFulfillmentTaskId",
    key: "stockId",
    status: true,
    width: 120,
  },
  {
    cnName: "任务类型",
    enName: "task type",
    key: "taskType",
    status: true,
    width: 120,
  },
  {
    cnName: "配货阶段",
    enName: "Allocation phase",
    key: "pickingStage",
    status: true,
    width: 120,
  },
  {
    cnName: "分拣阶段",
    enName: "Sorting stage",
    key: "sortingStage",
    status: true,
    width: 120,
  },
  {
    cnName: "发货阶段",
    enName: "Delivery phase",
    key: "shippingStage",
    status: true,
    width: 120,
  },
  {
    cnName: "是否为纸质任务",
    enName: "Whether it is a paper task",
    key: "isPaper",
    status: true,
    width: 120,
  },
  {
    cnName: "配货篮子(单品)",
    enName: "Allotment basket item",
    key: "pickingBasketID",
    status: true,
    width: 120,
  },
  {
    cnName: "分拣篮子",
    enName: "Shipping Basket",
    key: "sortingBasketID",
    status: true,
    width: 120,
  },
  {
    cnName: "多楼层组合配货",
    enName: "Multi floor combination distribution",
    key: "isMultiFloorPickingTask",
    status: true,
    width: 120,
  },
  {
    cnName: "单独分拣发货",
    enName: "Separate sorting and shipping",
    key: "isEntireSortJobShippable",
    status: true,
    width: 120,
  },
  {
    cnName: "边配货边发货",
    enName: "Distribute goods while shipping",
    key: "enablePickAndShipSimultaneously",
    status: true,
    width: 120,
  },
  {
    cnName: "订单数量",
    enName: "order quantity",
    key: "orderVolume",
    status: true,
    width: 120,
  },
  {
    cnName: "额外包材",
    enName: "Extra packing material",
    key: "hasExtraPackingMaterials",
    status: true,
    width: 120,
  },
  {
    cnName: "创建时间",
    enName: "creation time",
    key: "taskCreationTime",
    status: true,
    width: 120,
  },
  {
    cnName: "总配货数量",
    enName: "Total allocation quantity",
    key: "totalRequiredPickingQty",
    status: true,
    width: 120,
  },
  {
    cnName: "总分拣数量",
    enName: "Total sorting quantity",
    key: "totalSortingQty",
    status: true,
    width: 120,
  },
  {
    cnName: "总发货数量",
    enName: "Total shipment quantity",
    key: "totalShippingQty",
    status: true,
    width: 120,
  },
  {
    cnName: "配货开始时间",
    enName: "Distribution start time",
    key: "pickingStartTime",
    status: true,
    width: 120,
  },
  {
    cnName: "配货结束时间",
    enName: "Distribution end time",
    key: "pickingEndTime",
    status: true,
    width: 120,
  },
  {
    cnName: "配货人",
    enName: "distributor",
    key: "distributor",
    status: true,
    width: 120,
  },
  {
    cnName: "分拣开始时间",
    enName: "Sorting start time",
    key: "sortingStartTime",
    status: true,
    width: 120,
  },
  {
    cnName: "分拣结束时间",
    enName: "Sorting end time",
    key: "sortingEndTime",
    status: true,
    width: 120,
  },
  {
    cnName: "分拣人",
    enName: "sorter",
    key: "sorter",
    status: true,
    width: 120,
  },
  {
    cnName: "发货开始时间",
    enName: "Delivery start time",
    key: "shippingStartTime",
    status: true,
    width: 120,
  },
  {
    cnName: "发货结束时间",
    enName: "Delivery end time",
    key: "shippingEndTime",
    status: true,
    width: 120,
  },
  {
    cnName: "发件人",
    enName: "consigner",
    key: "shipper",
    status: true,
    width: 120,
  },
  {
    cnName: "配货异常数量",
    enName: "Abnormal quantity of distribution",
    key: "exceptionalPickingQty",
    status: true,
    width: 120,
  },
  {
    cnName: "分拣异常数量",
    enName: "Sorting abnormal quantity",
    key: "exceptionalSortingQty",
    status: true,
    width: 120,
  },
  {
    cnName: "发货异常数量",
    enName: "Abnormal shipment quantity",
    key: "exceptionalShippingQty",
    status: true,
    width: 120,
  },
];

// 管理端 - 待发货任务列表
let managementListOrdersShipped = [
  {
    cnName: "订单号",
    enName: "order number",
    key: "orderNo",
    status: true,
    width: 120,
  },
  {
    cnName: "交易号",
    enName: "transaction number",
    key: "csRefNo",
    status: true,
    width: 120,
  },
  {
    cnName: "运单号",
    enName: "Waybill number",
    key: "trackingNo",
    status: true,
    width: 120,
  },
  {
    cnName: "任务ID",
    enName: "taskID",
    key: "orderFulfillmentTaskId",
    status: true,
    width: 120,
  },
  {
    cnName: "客户ID",
    enName: "Customer ID",
    key: "customerId",
    status: true,
    width: 120,
  },
  {
    cnName: "分拣篮子编号",
    enName: "Sorting basket number",
    key: "sortingNo",
    status: true,
    width: 120,
  },
  {
    cnName: "渠道类型",
    enName: "Channel type",
    key: "labelType",
    status: true,
    width: 120,
  },
  {
    cnName: "优先交付",
    enName: "Priority delivery",
    key: "isPriorityDelivery",
    status: true,
    width: 120,
  },
  {
    cnName: "平台",
    enName: "platform",
    key: "platformStyle",
    status: true,
    width: 120,
  },
  {
    cnName: "订单类型",
    enName: "Order types",
    key: "fulfillmentType",
    status: true,
    width: 120,
  },
  {
    cnName: "额外包材",
    enName: "Extra packing material",
    key: "hasExtraPackingMaterials",
    status: true,
    width: 120,
  },
  {
    cnName: "总立方",
    enName: "Gross cube",
    key: "totalCubicDetails",
    status: true,
    width: 120,
  },
  {
    cnName: "订单来源",
    enName: "order source",
    key: "orderType",
    status: true,
    width: 120,
  },
  {
    cnName: "重量",
    enName: "weight",
    key: "shipmentWeighed",
    status: true,
    width: 120,
  },
  {
    cnName: "配货篮子(单品)",
    enName: "Allotment basket item",
    key: "pickingBasketID",
    status: true,
    width: 120,
  },
  {
    cnName: "配货人",
    enName: "distributor",
    key: "distributor",
    status: true,
    width: 120,
  },
  {
    cnName: "分拣篮子",
    enName: "Shipping Basket",
    key: "sortingBasketID",
    status: true,
    width: 120,
  },
  {
    cnName: "分拣人",
    enName: "sorter",
    key: "sorter",
    status: true,
    width: 120,
  },
  {
    cnName: "发件人",
    enName: "consigner",
    key: "shipper",
    status: true,
    width: 120,
  },
  {
    cnName: "仓库",
    enName: "warehouse",
    key: "stockId",
    status: true,
    width: 120,
  },
  {
    cnName: "创建时间",
    enName: "creation time",
    key: "createTime",
    status: true,
    width: 120,
  },
  {
    cnName: "确认时间",
    enName: "verify the time",
    key: "confirmTime",
    status: true,
    width: 120,
  },
];

// 管理端 - 已发货任务列表
let managementListShippedOrders = [
  {
    cnName: "订单号",
    enName: "order number",
    key: "orderNo",
    status: true,
    width: 120,
  },
  {
    cnName: "交易号",
    enName: "transaction number",
    key: "csRefNo",
    status: true,
    width: 120,
  },
  {
    cnName: "运单号",
    enName: "Waybill number",
    key: "trackingNo",
    status: true,
    width: 120,
  },
  {
    cnName: "任务ID",
    enName: "taskID",
    key: "orderFulfillmentTaskId",
    status: true,
    width: 120,
  },
  {
    cnName: "客户ID",
    enName: "Customer ID",
    key: "customerId",
    status: true,
    width: 120,
  },
  {
    cnName: "分拣篮子编号",
    enName: "Sorting basket number",
    key: "sortingNo",
    status: true,
    width: 120,
  },
  {
    cnName: "渠道类型",
    enName: "Channel type",
    key: "labelType",
    status: true,
    width: 120,
  },
  {
    cnName: "优先交付",
    enName: "Priority delivery",
    key: "isPriorityDelivery",
    status: true,
    width: 120,
  },
  {
    cnName: "平台",
    enName: "platform",
    key: "platformStyle",
    status: true,
    width: 120,
  },
  {
    cnName: "订单类型",
    enName: "Order types",
    key: "fulfillmentType",
    status: true,
    width: 120,
  },
  {
    cnName: "额外包材",
    enName: "Extra packing material",
    key: "hasExtraPackingMaterials",
    status: true,
    width: 120,
  },
  {
    cnName: "总立方",
    enName: "Gross cube",
    key: "totalCubicDetails",
    status: true,
    width: 120,
  },
  {
    cnName: "订单来源",
    enName: "order source",
    key: "orderType",
    status: true,
    width: 120,
  },
  {
    cnName: "重量",
    enName: "weight",
    key: "shipmentWeighed",
    status: true,
    width: 120,
  },
  {
    cnName: "配货篮子(单品)",
    enName: "Allotment basket item",
    key: "pickingBasketID",
    status: true,
    width: 120,
  },
  {
    cnName: "配货人",
    enName: "distributor",
    key: "distributor",
    status: true,
    width: 120,
  },
  {
    cnName: "分拣篮子",
    enName: "Shipping Basket",
    key: "sortingBasketID",
    status: true,
    width: 120,
  },
  {
    cnName: "分拣人",
    enName: "sorter",
    key: "sorter",
    status: true,
    width: 120,
  },
  {
    cnName: "发件人",
    enName: "consigner",
    key: "shipper",
    status: true,
    width: 120,
  },
  {
    cnName: "仓库",
    enName: "warehouse",
    key: "stockId",
    status: true,
    width: 120,
  },
  {
    cnName: "创建时间",
    enName: "verify the time",
    key: "confirmTime",
    status: true,
    width: 120,
  },
  {
    cnName: "出库时间",
    enName: "delivery time",
    key: "deliveryTime",
    status: true,
    width: 120,
  },
];

/**
 * 处理字段的新增修改
 * @param {backendData} 后端数据
 * @param {frontendData} 前端数据
 * @returns
 */
function mergeArrays(backendData, frontendData) {
  const matchedItems = [];
  const unmatchedItems = [];
  const processedFrontendIndices = new Set();

  // 先处理后端数据，按后端顺序收集匹配项
  backendData.forEach((backendItem) => {
    const frontendIndex = frontendData.findIndex(
      (frontendItem) =>
        frontendItem.key === backendItem.key ||
        (frontendItem.cnName &&
          backendItem.cnName &&
          frontendItem.cnName === backendItem.cnName) ||
        (frontendItem.enName &&
          backendItem.enName &&
          frontendItem.enName === backendItem.enName) ||
        (frontendItem.langLabel &&
          backendItem.langLabel &&
          frontendItem.langLabel === backendItem.langLabel)
    );

    if (frontendIndex !== -1 && !processedFrontendIndices.has(frontendIndex)) {
      const frontendItem = frontendData[frontendIndex];
      processedFrontendIndices.add(frontendIndex);

      if (backendItem.status === false) {
        return;
      }

      const isAllFieldsChanged =
        frontendItem.key !== backendItem.key &&
        ((frontendItem.cnName &&
          backendItem.cnName &&
          frontendItem.cnName !== backendItem.cnName &&
          frontendItem.enName &&
          backendItem.enName &&
          frontendItem.enName !== backendItem.enName) ||
          (frontendItem.langLabel &&
            backendItem.langLabel &&
            frontendItem.langLabel !== backendItem.langLabel));

      if (isAllFieldsChanged) {
        unmatchedItems.push({
          ...backendItem,
          cnName: frontendItem.cnName,
          enName: frontendItem.enName,
          langLabel: frontendItem.langLabel,
          key: frontendItem.key,
          status: backendItem.status,
        });
      } else {
        matchedItems.push({
          ...backendItem,
          cnName: frontendItem.cnName,
          enName: frontendItem.enName,
          langLabel: frontendItem.langLabel,
          key: frontendItem.key,
          status: backendItem.status,
        });
      }
    }
  });

  // 处理前端中未匹配的项
  frontendData.forEach((frontendItem, index) => {
    if (!processedFrontendIndices.has(index)) {
      unmatchedItems.push(frontendItem);
    }
  });

  return [...matchedItems, ...unmatchedItems];
}

import { deepClone } from "@/plugins/childrenPage";
// 删除宽度
function deleteWidth(list, excludeList = []) {
  let temp = deepClone(list);
  temp.forEach((item) => {
    delete item.status;
    if (excludeList.includes(item.key) || item.width != 120) {
      return;
    }
    delete item.width;
  });
  return temp;
}

// 插入空对象
function insertEmptyObject(list, indexList) {
  let temp = deepClone(list);
  for (let i = 0; i < indexList.length; i++) {
    temp.splice(indexList[i], 0, {});
  }
  return temp;
}

// 获取表格字段
function getFields(
  vm,
  firstrequest = false,
  fn,
  treeListRefName = "treeListRef"
) {
  vm.$api
    .post("/api/PathNavigationSwitch/PathNavigationSwitchPageList", vm.diyName)
    .then(async (res) => {
      vm.fieldList = res.data;
      let filterData = res.data.filter((item) => item.isActive);

      if (filterData.length) {
        if (firstrequest) {
          vm.$refs[treeListRefName].defaultStyle();
        }
        let temp = JSON.parse(filterData[0].styleJson);
        vm.fields = temp;
        vm.columnCount = filterData[0].count || 1;
      } else {
        vm.fields = [];
      }


      if (!firstrequest) {
        vm.$refs[treeListRefName].defaultStyle();
        await vm.$getTableSort(vm, vm.tableSortName || undefined);
        fn();
      }
    });
}

// 获取语言
function getLang(name) {
  let temp = name.toLowerCase(); // 转换为小写
  temp = temp.replace(/\s/g, "_"); // 替换空格为下划线
  const foundKey = Object.keys(Chinese).find(
    (key) => key.toLowerCase() === temp
  );
  return foundKey;
}

// 获取字段名称
function getLangName(item, locale, transferEnName = true) {
  let langName = "";
  // 存在langLabel - 多语言标识
  if (item.langLabel) {
    // 数组类型 - 由多个词组成
    if (Array.isArray(item.langLabel)) {
      langName = item.langLabel.map((label) => i18n.t(label)).join("");
    } else {
      langName = i18n.t(item.langLabel);
    }
  } else if (transferEnName) {
    // 多语言文件中存在可匹配的enName
    if (item.enName && getLang(item.enName)) {
      langName = i18n.t(getLang(item.enName));
    } else if (item.EnName && getLang(item.EnName)) {
      langName = i18n.t(getLang(item.EnName));
    } else {
      langName =
        locale == "zh"
          ? item.cnName || item.CnName
          : item.enName || item.EnName;
    }
  } else {
    langName =
      locale == "zh" ? item.cnName || item.CnName : item.enName || item.EnName;
  }

  return langName;
}

/**
 *
 * @param {fields} 当前字段表
 * @param {originalData} 初始字段数据
 * @param {locale} locale 当前语言
 * @param {columnCount} 一列个数
 * @param {processHeaderRender} 特殊处理头部方法
 * @param {processColumnRender} 特殊处理行方法
 * @param {copyList} 可拷贝字段
 * @param {sortList} 可排序字段
 * @param {sortFunction} 排序调用方法
 * @param {tableSort} 排序
 * @param {popoverList} 可悬浮字段
 * @param {popoverConfig} 悬浮配置
//  * 使用示例
popoverList: ['storeName', 'itemName'],
popoverConfig: {
  // storeName 超过 2 行显示省略号，并显示复制按钮
  storeName: { lines: 2, showCopy: true },
  // itemName 超过 3 行显示省略号，不显示复制图标
  itemName: { lines: 3, showCopy: false },
},
 * @param {imageList} 图片字段
 * @param {specailPage} 特殊页面
 * @param {staffIdList} 员工id字段
 * @param {totalPosition} 源表格合计
 * @param {hasTotalPosition} 是否存在表格合计
 * @param {hasExpand} 是否可展开
 * @param {hasSelection} 是否可选择
 * @returns
 */
function processCustomFieldConfig({
  fields = [],
  originalData = [],
  locale = "zh",
  columnCount = 1,
  processHeaderRender,
  processColumnRender,
  copyList = ["customerId", "sku", "storeName"],
  sortList = [],
  sortFunction,
  tableSort,
  popoverList = [],
  popoverConfig = {},
  imageList = [],
  popoverAndCopyList = [],
  specailPage,
  staffIdList = [],
  delLastWidth = true,
  currencyIdList = ["currencyId"],
  totalPosition = [],
  hasTotalPosition = false,
  hasExpand = false,
  hasSelection = true,
  platformImageList = [],
  channelTypeList = ["channelType"],
  countryIdList = ["countryId"],
  stockIdList = ["stockId"],
  basketList = [],
  tableSortEventName = undefined,
}) {
  let wholeData = [];
  // 筛选出激活字段
  let activeList = mergeArrays(fields, originalData);

  // 二次筛选出图片字段（需单独一列展示）
  let imageField = [];
  if (
    imageList.length &&
    activeList.filter((item) => imageList.includes(item.key))
  ) {
    activeList.map((item, index) => {
      if (imageList.includes(item.key)) {
        imageField.push({
          position: index,
          content: item,
        });
      }
    });
  }

  // 删除源图片字段
  for (let i = imageField.length - 1; i >= 0; i--) {
    activeList.splice(imageField[i].position, 1);
  }

  // 根据一列展示个数处理字段列表
  let temp = [];
  for (let i = 0; i < activeList.length; i += columnCount) {
    temp.push(activeList.slice(i, i + columnCount));
  }

  // 处理图片位置
  if (imageField.length) {
    imageField.map((item) => {
      let position = Math.ceil(item.position / columnCount);
      temp.splice(position, 0, [item.content]);
    });
  }

  // 特殊页面索引（默认为首个时插入，遇到图片需特殊处理）
  let specailIndex = 0;
  if (temp[0].some((item) => imageList.includes(item.key))) {
    specailIndex = 1;
  }

  let newTotalPosition = [];
  if (totalPosition.length) {
    totalPosition.forEach((item) => {
      let found = false;
      // 遍历二级数组temp查找对应key
      for (let i = 0; i < temp.length; i++) {
        const subArray = temp[i];
        for (let j = 0; j < subArray.length; j++) {
          if (subArray[j].key === item.value) {
            // 创建新对象存入新数组
            let column = i;
            if (hasExpand && hasSelection) {
              column = i + 2;
            } else if (hasExpand && !hasSelection) {
              column = i + 1;
            } else if (!hasExpand && hasSelection) {
              column = i + 1;
            }
            newTotalPosition.push({
              column: column, // temp一级索引
              line: j, // temp二级索引
              value: item.value, // 源value
              decimalPlace: item.decimalPlace, // 源decimalPlace
            });
            found = true;
            break;
          }
        }
        if (found) break;
      }
    });
  }

  temp.map((item, index) => {
    // 设置宽度（一列多个取最大）
    let width = 0;
    let label = "";
    let fixed = false;
    item.map((child) => {
      if (child.width > width) {
        width = child.width;
      }
      label += `${getLangName(child, locale)}\n`;
      if (!fixed && child.fixed) {
        fixed = true;
      }
    });
    wholeData.push({
      value: item,
      width: width,
      label: label.slice(0, label.length - 1),
      fixed: fixed,
      // 处理头部
      headerRender: (h) => {
        let childTemp = [];
        item.map((child) => {
          let label = getLangName(child, locale);
          let result = h("div", label);
          // 可排序字段
          if (sortList.includes(child.key)) {
            result = h(
              "p",
              {
                on: {
                  click: () => {
                    sortFunction();
                  },
                },
              },
              [
                h(TableSort, {
                  props: {
                    sortText: label,
                    sortName: child.sortName || child.key,
                    sortBy: tableSort,
                    eventName: tableSortEventName || undefined,
                  },
                }),
              ]
            );
          }
          // 特殊字段
          if (processHeaderRender && processHeaderRender(h, label, child.key)) {
            result = processHeaderRender(h, label, child.key);
          }
          childTemp.push(result);
        });
        return h("div", {}, childTemp);
      },
      // 处理行
      columnRender: (h, params) => {
        let childTemp = [];
        item.map((child) => {
          if (child.key == undefined) {
            return;
          }
          let normalColumn = params.row[child.key];
          if (
            params.row[child.key] === "1900-01-01 00:00:00" ||
            params.row[child.key] === "0001-01-01 00:00:00"
          ) {
            normalColumn = "-";
          }
          if (!params.row[child.key] && params.row[child.key] != "0") {
            normalColumn = "-";
          }
          let result = h("div", normalColumn);
          // 可拷贝字段
          if (copyList.includes(child.key)) {
            result = h(
              "p",
              {
                class: "iconP",
                slot: "reference",
                attrs: { slot: "reference" },
              },
              [
                h("span", params.row[child.key] || "-"),
                h("i", {
                  class: "el-icon-document-copy pointer icon green-Cd0100",
                  style: { marginLeft: "4px" },
                  on: {
                    click: () => {
                      copyText(
                        params.row[child.copyKey] || params.row[child.key]
                      );
                    },
                  },
                }),
              ]
            );
          }
          // 可悬浮字段（支持行数变化显示与可选复制）
          if (popoverList.includes(child.key)) {
            const rawText = params.row[child.key];
            const displayText =
              rawText === undefined || rawText === null || rawText === ""
                ? "-"
                : String(rawText);
            const cfg = popoverConfig[child.key] || {};
            const lines = cfg.lines || 1;
            const showCopy = cfg.showCopy;
            const lineStyle = {
              display: "-webkit-box",
              WebkitBoxOrient: "vertical",
              WebkitLineClamp: String(lines),
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "normal",
            };
            result = h(
              "el-popover",
              {
                attrs: {
                  placement: "top",
                  trigger: "hover",
                  width: 400,
                  disabled: !rawText,
                },
              },
              [
                h("div", [
                  h("span", displayText || "-"),
                  showCopy &&
                    h("i", {
                      class: "el-icon-document-copy pointer icon green-Cd0100",
                      on: {
                        click: () => {
                          copyText(displayText); // 执行复制操作
                        },
                      },
                    }),
                ]),
                h(
                  "p",
                  {
                    class: "iconP",
                    slot: "reference",
                    attrs: { slot: "reference" },
                    style: lineStyle,
                  },
                  displayText || "-"
                ),
              ]
            );
          }
          // 悬浮复制字段
          popoverAndCopyList.includes(child.key)
            ? (result = fieldPopoverAndCopy(h, params.row[child.key]))
            : "";
          // 图片字段
          imageList.includes(child.key)
            ? (result = h(
                "el-popover",
                {
                  attrs: {
                    placement: "top-start",
                    trigger: "hover",
                    width: "300",
                  },
                },
                [
                  h(
                    "el-image",
                    {
                      props: {
                        src: params.row[child.key] || ErrorImage,
                        fit: params.row[child.key] || ErrorImage,
                      },
                      style: {
                        width: "300px",
                        height: "300px",
                      },
                    },
                    [
                      h("div", { slot: "error", class: "image-slot" }, [
                        h("img", {
                          style: {
                            width: "100%",
                          },
                          attrs: {
                            src: ErrorImage,
                          },
                        }),
                      ]),
                    ]
                  ),
                  h(
                    "el-image",
                    {
                      slot: "reference",
                      style: {
                        width: child.imageWidth || "40px",
                        height: child.imageWidth || "40px",
                      },
                      props: {
                        src: params.row[child.key],
                        fit: params.row[child.key],
                        previewSrcList: [params.row[child.key]],
                      },
                    },
                    [
                      h("div", { slot: "error", class: "image-slot" }, [
                        h("img", {
                          style: {
                            width: "100%",
                          },
                          attrs: {
                            src: ErrorImage,
                          },
                        }),
                      ]),
                    ]
                  ),
                ]
              ))
            : "";
          // 平台图片字段
          if (platformImageList.includes(child.key)) {
            let platformData = window.localStorage.getItem("platform")
              ? JSON.parse(AES.decrypt(window.localStorage.getItem("platform")))
              : Platform;
            let platformItem = platformData.find(
              (item) => item.value == params.row[child.key]
            );
            if (platformItem) {
              let fieleName = platformItem.enName || platformItem.EnName;
              let imgUrl = require(`@/assets/images/platform/${fieleName}.png`);
              result = h("img", {
                attrs: {
                  src: imgUrl,
                },
              });
            } else {
              result = h("div", "-");
            }
          }
          // 仓库
          if (stockIdList.includes(child.key)) {
            // result = h("div", params.row[child.key + 'CustomizeName']);
            result = h(WarehouseP, { attrs: { id: params.row[child.key] } });
          }
          // 国家
          if (countryIdList.includes(child.key)) {
            // result = h("div", params.row[child.key + 'CustomizeName']);
            result = h(CountryP, { attrs: { id: params.row[child.key] } });
          }
          // 中转仓库
          if (["transitWarehouseId"].includes(child.key)) {
            // result = h("div", params.row[child.key + 'CustomizeName']);
            result = h(TransitWarehouseP, {
              attrs: { id: params.row[child.key] },
            });
          }
          // 渠道
          if (channelTypeList.includes(child.key)) {
            // result = h("div", params.row[child.key + 'CustomizeName']);
            result = h(channelTypeP, { attrs: { id: params.row[child.key] } });
          }
          // 员工
          if (staffIdList.includes(child.key)) {
            result = h(staffP, { attrs: { id: params.row[child.key] } });
          }
          // 币种
          if (currencyIdList.includes(child.key)) {
            result = h(CurrencyP, { attrs: { id: params.row[child.key] } });
          }
          // 篮子
          if (basketList.includes(child.key)) {
            result = h(basketP, { attrs: { id: params.row[child.key] } });
          }
          // 特殊字段
          if (
            processColumnRender &&
            processColumnRender(h, params, child.key)
          ) {
            result = processColumnRender(h, params, child.key);
          }
          childTemp.push(result);
        });

        // 处理特殊页面
        // 客户端头程订单列表
        if (specailPage === "clientFirstLegOrderList") {
          if (index === specailIndex) {
            childTemp.push(processColumnRender(h, params, "firstBillingStage"));
          }
        }
        // 客户端头程账单列表
        if (specailPage === "clientFirstBillingList") {
          if (index === specailIndex) {
            childTemp.push(processColumnRender(h, params, "firstBillingStage"));
          }
        }
        // 客户端入库单列表
        if (specailPage === "clientWarehouseEntryList") {
          if (index === specailIndex) {
            childTemp.push(
              processColumnRender(h, params, "statusOfStorageReceipt")
            );
          }
        }
        // 客户端仓储订单列表
        if (
          specailPage === "clientInventoryOrderList" ||
          specailPage === "clientInventoryAllOrderList"
        ) {
          if (index === specailIndex) {
            childTemp.push(processColumnRender(h, params, "orderStatus"));
          }
        }
        // 客户端取消订单列表
        if (specailPage === "clientCancellationOrder") {
          if (index === specailIndex) {
            childTemp.push(processColumnRender(h, params, "orderStatus"));
          }
        }

        // 客户端订单--异常交运列表
        if (specailPage === "abnormalInventoryOrderist") {
          if (index === specailIndex) {
            childTemp.push(processColumnRender(h, params, "orderStatus"));
          }
        }

        // 管理端头程订单列表
        if (specailPage === "managementFirstLegOrderList") {
          if (index === specailIndex) {
            childTemp.push(processColumnRender(h, params, "firstBillingStage"));
          }
        }
        // 管理端头程订单列表
        if (specailPage === "managementFirstBillingList") {
          if (index === specailIndex) {
            childTemp.push(processColumnRender(h, params, "firstOrderStage"));
          }
        }
        // 管理端头程订单列表
        if (specailPage === "managementWarehouseEntryList") {
          if (index === specailIndex) {
            childTemp.push(
              processColumnRender(h, params, "statusOfStorageReceipt")
            );
          }
        }
        // 管理端仓储订单列表
        if (
          specailPage === "managementInventoryOrderList" ||
          specailPage === "managementInventoryAllOrderList"
        ) {
          if (index === specailIndex) {
            childTemp.push(processColumnRender(h, params, "orderStatus"));
          }
        }
        // 管理端取消订单列表
        if (specailPage === "cancellationOrderList") {
          if (index === specailIndex) {
            childTemp.push(processColumnRender(h, params, "orderStatus"));
          }
        }
        return h("div", {}, childTemp);
      },
    });
  });

  if (delLastWidth) {
    // 删除最后一列的宽度，预防表格显示无法满足100%页面宽度
    delete wholeData[wholeData.length - 1]["width"];
  }

  if (!hasTotalPosition) {
    return wholeData;
  }
  return {
    wholeData: wholeData,
    totalPosition: newTotalPosition,
  };
}

export {
  deleteWidth,
  insertEmptyObject,
  getFields,
  processCustomFieldConfig,
  getFieldName,
  clientInventoryOrderList,
  clientInventoryAllOrderList,
  clientCancellationOrder,
  abnormalInventoryOrderist,
  clientFirstLegOrderList,
  clientFirstBillingList,
  clientWarehouseEntryList,
  clientInventorySKUList,
  clientInventoryList,
  managementSideInventoryList,
  clientReturnList,
  clientPackagingMaterialManagement,
  managementFirstLegOrderList,
  managementFirstBillingList,
  managementWarehouseEntryList,
  managementWarehouseReceiptList,
  managementInventoryEntryListChecked,
  managementInventoryEntryList,
  managementInventorySKUList,
  managementInventoryOrderList,
  managementInventoryAllOrderList,
  cancellationOrderList,
  managementTaskList,
  managementListOrdersShipped,
  managementListShippedOrders,
  getLang,
  getLangName,
};
